var cartQtyLock = false;

var bodyScrollLockOptions = {
    reserveScrollBarGap: true,
};

let trapFocusData = {
  container: null,
  first: null,
  last: null,
  previouslyFocused: null,
  keydownHandler: null,
};

function getFocusableElements(container) {
  if (!(container instanceof HTMLElement)) {
    console.warn('getFocusableElements: container is not a valid HTMLElement', container);
    return [];
  }

  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe, .focusable"
    )
  ).filter(el => el.offsetParent !== null); // samo vidljivi
}

function trapFocus(container) {
  removeTrapFocus();

  const elements = getFocusableElements(container);
  if (!elements.length) return;

  trapFocusData.container = container;
  trapFocusData.first = elements[0];
  trapFocusData.last = elements[elements.length - 1];
  trapFocusData.previouslyFocused = document.activeElement;

  trapFocusData.first.focus();

  trapFocusData.keydownHandler = (event) => {
    if (event.key !== 'Tab') return;

    const { first, last } = trapFocusData;
    const isTabForward = !event.shiftKey;
    const isTabBackward = event.shiftKey;

    if (isTabForward && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }

    if (isTabBackward && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('keydown', trapFocusData.keydownHandler);
}

function removeTrapFocus() {
  if (trapFocusData.keydownHandler) {
    document.removeEventListener('keydown', trapFocusData.keydownHandler);
  }

  if (
    trapFocusData.previouslyFocused &&
    typeof trapFocusData.previouslyFocused.focus === 'function'
  ) {
    trapFocusData.previouslyFocused.focus();
  }

  trapFocusData = {
    container: null,
    first: null,
    last: null,
    previouslyFocused: null,
    keydownHandler: null,
  };
}


//DOM DELEGATE
/**
 * DOM event delegator
 *
 * The delegator will listen
 * for events that bubble up
 * to the root node.
 *
 * @constructor
 * @param {Node|string} [root] The root node or a selector string matching the root node
 */
function Delegate(root) {
  /**
   * Maintain a map of listener
   * lists, keyed by event name.
   *
   * @type Object
   */
  this.listenerMap = [{}, {}];
  if (root) {
    this.root(root);
  }

  /** @type function() */
  this.handle = Delegate.prototype.handle.bind(this);

  // Cache of event listeners removed during an event cycle
  this._removedListeners = [];
}

/**
 * Start listening for events
 * on the provided DOM element
 *
 * @param  {Node|string} [root] The root node or a selector string matching the root node
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.root = function (root) {
  const listenerMap = this.listenerMap;
  let eventType;

  // Remove master event listeners
  if (this.rootElement) {
    for (eventType in listenerMap[1]) {
      if (listenerMap[1].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, true);
      }
    }
    for (eventType in listenerMap[0]) {
      if (listenerMap[0].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, false);
      }
    }
  }

  // If no root or root is not
  // a dom node, then remove internal
  // root reference and exit here
  if (!root || !root.addEventListener) {
    if (this.rootElement) {
      delete this.rootElement;
    }
    return this;
  }

  /**
   * The root node at which
   * listeners are attached.
   *
   * @type Node
   */
  this.rootElement = root;

  // Set up master event listeners
  for (eventType in listenerMap[1]) {
    if (listenerMap[1].hasOwnProperty(eventType)) {
      this.rootElement.addEventListener(eventType, this.handle, true);
    }
  }
  for (eventType in listenerMap[0]) {
    if (listenerMap[0].hasOwnProperty(eventType)) {
      this.rootElement.addEventListener(eventType, this.handle, false);
    }
  }

  return this;
};

/**
 * @param {string} eventType
 * @returns boolean
 */
Delegate.prototype.captureForType = function (eventType) {
  return (
    ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(
      eventType
    ) !== -1
  );
};

/**
 * Attach a handler to one
 * event for all elements
 * that match the selector,
 * now or in the future
 *
 * The handler function receives
 * three arguments: the DOM event
 * object, the node that matched
 * the selector while the event
 * was bubbling and a reference
 * to itself. Within the handler,
 * 'this' is equal to the second
 * argument.
 *
 * The node that actually received
 * the event can be accessed via
 * 'event.target'.
 *
 * @param {string} eventType Listen for these events
 * @param {string|undefined} selector Only handle events on elements matching this selector, if undefined match root element
 * @param {function()} handler Handler function - event data passed here will be in event.data
 * @param {boolean} [useCapture] see 'useCapture' in <https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener>
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.on = function (eventType, selector, handler, useCapture) {
  let root;
  let listenerMap;
  let matcher;
  let matcherParam;

  if (!eventType) {
    throw new TypeError("Invalid event type: " + eventType);
  }

  // handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // Fallback to sensible defaults
  // if useCapture not set
  if (useCapture === undefined) {
    useCapture = this.captureForType(eventType);
  }

  if (typeof handler !== "function") {
    throw new TypeError("Handler must be a type of Function");
  }

  root = this.rootElement;
  listenerMap = this.listenerMap[useCapture ? 1 : 0];

  // Add master handler for type if not created yet
  if (!listenerMap[eventType]) {
    if (root) {
      root.addEventListener(eventType, this.handle, useCapture);
    }
    listenerMap[eventType] = [];
  }

  if (!selector) {
    matcherParam = null;

    // COMPLEX - matchesRoot needs to have access to
    // this.rootElement, so bind the function to this.
    matcher = matchesRoot.bind(this);

    // Compile a matcher for the given selector
  } else if (/^[a-z]+$/i.test(selector)) {
    matcherParam = selector;
    matcher = matchesTag;
  } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
    matcherParam = selector.slice(1);
    matcher = matchesId;
  } else {
    matcherParam = selector;
    matcher = Element.prototype.matches;
  }

  // Add to the list of listeners
  listenerMap[eventType].push({
    selector: selector,
    handler: handler,
    matcher: matcher,
    matcherParam: matcherParam,
  });

  return this;
};

/**
 * Remove an event handler
 * for elements that match
 * the selector, forever
 *
 * @param {string} [eventType] Remove handlers for events matching this type, considering the other parameters
 * @param {string} [selector] If this parameter is omitted, only handlers which match the other two will be removed
 * @param {function()} [handler] If this parameter is omitted, only handlers which match the previous two will be removed
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.off = function (eventType, selector, handler, useCapture) {
  let i;
  let listener;
  let listenerMap;
  let listenerList;
  let singleEventType;

  // Handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // If useCapture not set, remove
  // all event listeners
  if (useCapture === undefined) {
    this.off(eventType, selector, handler, true);
    this.off(eventType, selector, handler, false);
    return this;
  }

  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  if (!eventType) {
    for (singleEventType in listenerMap) {
      if (listenerMap.hasOwnProperty(singleEventType)) {
        this.off(singleEventType, selector, handler);
      }
    }

    return this;
  }

  listenerList = listenerMap[eventType];
  if (!listenerList || !listenerList.length) {
    return this;
  }

  // Remove only parameter matches
  // if specified
  for (i = listenerList.length - 1; i >= 0; i--) {
    listener = listenerList[i];

    if (
      (!selector || selector === listener.selector) &&
      (!handler || handler === listener.handler)
    ) {
      this._removedListeners.push(listener);
      listenerList.splice(i, 1);
    }
  }

  // All listeners removed
  if (!listenerList.length) {
    delete listenerMap[eventType];

    // Remove the main handler
    if (this.rootElement) {
      this.rootElement.removeEventListener(eventType, this.handle, useCapture);
    }
  }

  return this;
};

/**
 * Handle an arbitrary event.
 *
 * @param {Event} event
 */
Delegate.prototype.handle = function (event) {
  let i;
  let l;
  const type = event.type;
  let root;
  let phase;
  let listener;
  let returned;
  let listenerList = [];
  let target;
  const eventIgnore = "ftLabsDelegateIgnore";

  if (event[eventIgnore] === true) {
    return;
  }

  target = event.target;

  // Hardcode value of Node.TEXT_NODE
  // as not defined in IE8
  if (target.nodeType === 3) {
    target = target.parentNode;
  }

  // Handle SVG <use> elements in IE
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  root = this.rootElement;

  phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);

  // eslint-disable-next-line default-case
  switch (phase) {
    case 1: //Event.CAPTURING_PHASE:
      listenerList = this.listenerMap[1][type];
      break;
    case 2: //Event.AT_TARGET:
      if (this.listenerMap[0] && this.listenerMap[0][type]) {
        listenerList = listenerList.concat(this.listenerMap[0][type]);
      }
      if (this.listenerMap[1] && this.listenerMap[1][type]) {
        listenerList = listenerList.concat(this.listenerMap[1][type]);
      }
      break;
    case 3: //Event.BUBBLING_PHASE:
      listenerList = this.listenerMap[0][type];
      break;
  }

  let toFire = [];

  // Need to continuously check
  // that the specific list is
  // still populated in case one
  // of the callbacks actually
  // causes the list to be destroyed.
  l = listenerList.length;
  while (target && l) {
    for (i = 0; i < l; i++) {
      listener = listenerList[i];

      // Bail from this loop if
      // the length changed and
      // no more listeners are
      // defined between i and l.
      if (!listener) {
        break;
      }

      if (
        target.tagName &&
        ["button", "input", "select", "textarea"].indexOf(
          target.tagName.toLowerCase()
        ) > -1 &&
        target.hasAttribute("disabled")
      ) {
        // Remove things that have previously fired
        toFire = [];
      }
      // Check for match and fire
      // the event if there's one
      //
      // TODO:MCG:20120117: Need a way
      // to check if event#stopImmediatePropagation
      // was called. If so, break both loops.
      else if (listener.matcher.call(target, listener.matcherParam, target)) {
        toFire.push([event, target, listener]);
      }
    }

    // TODO:MCG:20120117: Need a way to
    // check if event#stopPropagation
    // was called. If so, break looping
    // through the DOM. Stop if the
    // delegation root has been reached
    if (target === root) {
      break;
    }

    l = listenerList.length;

    // Fall back to parentNode since SVG children have no parentElement in IE
    target = target.parentElement || target.parentNode;

    // Do not traverse up to document root when using parentNode, though
    if (target instanceof HTMLDocument) {
      break;
    }
  }

  let ret;

  for (i = 0; i < toFire.length; i++) {
    // Has it been removed during while the event function was fired
    if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
      continue;
    }
    returned = this.fire.apply(this, toFire[i]);

    // Stop propagation to subsequent
    // callbacks if the callback returned
    // false
    if (returned === false) {
      toFire[i][0][eventIgnore] = true;
      toFire[i][0].preventDefault();
      ret = false;
      break;
    }
  }

  return ret;
};

/**
 * Fire a listener on a target.
 *
 * @param {Event} event
 * @param {Node} target
 * @param {Object} listener
 * @returns {boolean}
 */
Delegate.prototype.fire = function (event, target, listener) {
  return listener.handler.call(target, event, target);
};

/**
 * Check whether an element
 * matches a tag selector.
 *
 * Tags are NOT case-sensitive,
 * except in XML (and XML-based
 * languages such as XHTML).
 *
 * @param {string} tagName The tag name to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesTag(tagName, element) {
  return tagName.toLowerCase() === element.tagName.toLowerCase();
}

/**
 * Check whether an element
 * matches the root.
 *
 * @param {?String} selector In this case this is always passed through as null and not used
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesRoot(selector, element) {
  if (this.rootElement === window) {
    return (
      // Match the outer document (dispatched from document)
      element === document ||
      // The <html> element (dispatched from document.body or document.documentElement)
      element === document.documentElement ||
      // Or the window itself (dispatched from window)
      element === window
    );
  }
  return this.rootElement === element;
}

/**
 * Check whether the ID of
 * the element in 'this'
 * matches the given ID.
 *
 * IDs are case-sensitive.
 *
 * @param {string} id The ID to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesId(id, element) {
  return id === element.id;
}

/**
 * Short hand for off()
 * and root(), ie both
 * with no parameters
 *
 * @return void
 */
Delegate.prototype.destroy = function () {
  this.off();
  this.root();
};

// document.querySelectorAll('[role="button"]').forEach(el => {
//   el.addEventListener('keydown', (e) => {
//     if (e.key === 'Enter' || e.key === ' ') {
//       e.preventDefault();
//       el.click();
//     }
//   });
// });


class RevolutionAnimation {
  constructor() {}

  slideUp(element) {
    element.style.height = element.scrollHeight + "px";
    element.offsetHeight;
    element.style.height = 0;
  }

  slideDown(element) {
    if (element.style.height === "auto") {
      return;
    }

    element.style.height = element.scrollHeight + "px";
    element.setAttribute("aria-hidden", false);
    var transitionEnded = function transitionEnded(event) {
      if (event.propertyName === "height") {
        element.style.height = "auto"; // Allows the content to grow normally
        element.removeEventListener("transitionend", transitionEnded);
      }
    };

    element.addEventListener("transitionend", transitionEnded);
  }
}

class Dropdown {
  constructor(element) {
    this.element = element;
    this.domDelegate = new Delegate(this.element);
    this.bindEvents();
  }

  bindEvents() {
    this.domDelegate.on(
      "click",
      "[data-action=toggle-dropdown]",
      this.toggleDropdown.bind(this)
    );
  }
  openDropdown(elem) {
    const dropdownButton = elem.querySelector(".DropdownButton"),
      dropdownContent = elem.querySelector(".DropdownContent");

    dropdownButton.setAttribute("aria-expanded", true);
    new RevolutionAnimation().slideDown(dropdownContent);
  }

  closeDropdown(elem) {
    const dropdownButton = elem.querySelector(".DropdownButton"),
      dropdownContent = elem.querySelector(".DropdownContent");
    new RevolutionAnimation().slideUp(dropdownContent);
    dropdownButton.setAttribute("aria-expanded", false);
    setTimeout(function () {
      dropdownContent.setAttribute("aria-hidden", true);
    }, 250);
  }
  toggleDropdown(event, target) {
    event.preventDefault(event);
    const mainDropdown = target.closest(".Dropdown");
    var isOpen = target.getAttribute("aria-expanded") === "true";

    if (isOpen) {
      this.closeDropdown(mainDropdown, target);
    } else {
      this.openDropdown(mainDropdown, target);
    }
  }
}

class DropdownSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;


    this.carousel = new Dropdown(this.element);
  }
}
customElements.define("dropdown-section", DropdownSection);

class Drawer {
    constructor(element) {
      var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.element = element;
      this.delegateElement = new Delegate(this.element);
      this.delegateBody = new Delegate(document.body);
      if(this.element.getAttribute("id") === "sizeGuide"){
        this.pageOverlayElement = document.querySelector(
          ".sizeGuideOverlay"
        ); 
      } else {
        this.pageOverlayElement = document.querySelector(".pageOverlay");
      }
      
      this.onOpen = options["onOpen"] || function () { };
      this.onClose = options["onClose"] || function () { };
      this.isOpen = false;
  
      this.bindEvents();
    }
    bindEvents() {
      this.delegateBody.on(
          "click",
          '[data-action="open-drawer"][data-toggle-id="' + this.element.id + '"]',
          this.openDrawer.bind(this)
      );
      this.delegateBody.on(
          "click",
          '[data-action="close-drawer"][data-toggle-id="' + this.element.id + '"]',
          this.closeDrawer.bind(this)
      );
      this.delegateBody.on(
          "click",
          '[data-action="toggle-drawer"][data-toggle-id="' + this.element.id + '"]',
          this.toggleDrawer.bind(this)
      );
      this._openListener = this.openDrawer.bind(this);
      this._closeListener = this.closeDrawer.bind(this);
      //this.calculateMaxHeightListener = this.maxHeight.bind(this);
      window.addEventListener("resize", this.calculateMaxHeightListener);
      document.addEventListener("favorite-drawer:close", this.closeDrawer.bind(this));
      document.addEventListener("drawer:close", this.closeDrawer.bind(this));
    }
  
    toggleDrawer() {
      event.preventDefault();
      this.isOpen ? this.closeDrawer() : this.openDrawer();
    
    }

    closeDrawers(){
        let drawers = document.querySelectorAll('.drawer');
        let cart = document.querySelector('.cart');
        let search = document.querySelector('.SearchWrapper');
        let searchElement = search.getAttribute('aria-hidden');

        if (searchElement == 'false'){
            search.setAttribute('aria-hidden', 'true');
        }
        drawers.forEach((drawer) => {
            if(drawer.classList.contains('open')){
                drawer.classList.remove('open');
            }
        });
       
        if(cart.classList.contains('open')){
            cart.classList.remove('open');
        }
        
    }
  
    openDrawer() {
        
      if (this.isOpen) {
        return;
      }
      var drawers = document.querySelectorAll(
        '.Drawer--wrapper[aria-expanded="true"]'
      );
      drawers.forEach((item, i) => {
          item.setAttribute("aria-expanded", "false");
       
          item.isOpen = false;
      });
  
      if (this.element.getAttribute("id") == "sidebarDrawer") {
        document.querySelector(".SidebarDrawer__Close").style.display = "block";
        this.element.dispatchEvent(
          new CustomEvent("sidebar-drawer:open", {
            bubbles: true,
          })
        );
      } else if (this.element.getAttribute("id") == "favoritesDrawer") {
        this.element.dispatchEvent(
          new CustomEvent("favorite-product:open", {
            bubbles: true,
          })
        )
        this.element.removeAttribute('style');

      } else if (this.element.getAttribute("id") == "sizeGuide") {
        this.element.dispatchEvent(
          new CustomEvent("size-guide:open", {
            bubbles: true,
          })
        )
      };

      this.element.style.display = "block";

      requestAnimationFrame(() => {
        this.element.setAttribute("aria-expanded", "true");
      })

      this.pageOverlayElement.classList.add("is-visible");
      this.pageOverlayElement.addEventListener("click", this._closeListener);
      document.documentElement.classList.add('noScroll');
  
      this.isOpen = true;
     
      this.onOpen();
      this.closeDrawers();
      return false;
    }
  
    closeDrawer(event) {

      if (!this.isOpen) {
        return;
      }
      if (event) {
          event.preventDefault();
      }


      this.element.setAttribute("aria-expanded", "false");
      this.pageOverlayElement.classList.remove("is-visible");

      setTimeout(() => {
        this.element.style.display = "none";
      }, 300);

      this.pageOverlayElement.removeEventListener("click", this._closeListener);
      document.documentElement.classList.remove('noScroll');
      document.querySelector('.favIcon').style['pointer-events'] = 'unset';
      this.isOpen = false;
      this.onClose();

      if (this.element.getAttribute("id") == "sizeGuide") {
        this.element.dispatchEvent(
          new CustomEvent("size-guide:close", {
            bubbles: true,
          })
        )
      }else if (this.element.getAttribute("id") == "favoritesDrawer") {
        this.element.dispatchEvent(
          new CustomEvent("favorite-drawer:close", {
            bubbles: true,
          })
        )
      };
    }
  
  }

class SizeDrawer extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.parent = this.element.closest('.shopify-section');
        this.delegateElement = new Delegate(this.element);
        this.bindEvents();
    }
    bindEvents() {
        this.delegateElement.on(
            "click",
            '[data-action="create-drawer"]',
            this.createDrawer.bind(this)
        );

                   
    }
      
    createDrawer(event, target){
        const toggleID = event.target.getAttribute('data-toggle-id');
        console.log(toggleID)
        if(this.parent.querySelector('#'+toggleID)){
          this.parent.querySelector('#'+toggleID).remove();
        }
        var node = document.createElement('div');
        node.appendChild(this.element.querySelector('template').content.firstElementChild.cloneNode(true));
        this.parent.appendChild(node.firstChild);
        this.sizeDrawer = new Drawer(this.parent.querySelector('#'+toggleID));
        var newItem = document.body.querySelector('#'+toggleID);
        this.sizeDrawer.openDrawer();
        
          
      }

      
       
    }
    customElements.define("size-drawer", SizeDrawer);

    
    class RevolutionSelectbox {
        constructor(element, popover, additionalOverlay) {
          this.element = element;
          this.popover = popover;
          this.changeOverlay = additionalOverlay;
          this.domDelegate = new Delegate(this.element);
          this.delegateBody = new Delegate(document.body);
          this.dropdown = this.element.querySelector(".RevolutionSelectbox");
          this.isOpen = false;
          this.mainDropdown = this.element.querySelector(
            ".RevolutionSelectbox--Content"
          );
      
          this.mainDropdownContent = this.element.querySelector(
            ".RevolutionSelectbox--InnerContent"
          );
          this.mainButton = this.element.querySelector(".RevolutionSelectbox--Button");
      
          this.connectedSelect = this.element.getAttribute("data-select");
          this.selectbox = this.element.querySelector(
            "[name=" + this.connectedSelect + "]"
          );
          if (this.selectbox == null) {
            this.selectbox = this.element.querySelector(
              "[name2=" + this.connectedSelect + "]"
            );
          }
          if (this.popover == true) {
            this.mainDropdown.classList.remove("RevolutionSelectbox--animation");
            this.mainDropdown.classList.add("PopoverContent");
            if (this.changeOverlay) {
              this.pageOverlayElement = document.querySelector(
                ".localizationOverlay"
              );
            } else {
              this.pageOverlayElement = document.querySelector(".pageOverlay");
            }
          }
          this.bindEvents();
          this.initSelectbox();
        }
      
        bindEvents() {
          this.onClickOutsideListener = this.onClickOutside.bind(this);
          this.domDelegate.on(
            "click",
            "[data-action=toggle-selectbox]",
            this.toggleDropdown.bind(this)
          );
      
          this.domDelegate.on(
            "click",
            "[data-action=selectbox-submit]",
            this.selectboxSubmit.bind(this)
          );
          this.domDelegate.on(
            "keypress",
            "[data-action=selectbox-submit]",
            this.selectboxSubmit.bind(this)
          );
      
          this.domDelegate.on(
            "click",
            "[data-action=selectbox-change]",
            this.selectboxChange.bind(this)
          );
      
          this.delegateBody.on("menu:open", this.onClickOutside.bind(this));
          this.domDelegate.on("click", "body", this.onClickOutside.bind(this));
        }
      
        selectboxChange() {
          var value = event.target.getAttribute("data-value");
          var selectboxID = event.target.getAttribute("data-selectboxid");
          var innerContent = event.target.innerHTML;
          var selEl = this.element.querySelector("#" + selectboxID);
          if (selEl.nodeName == "SELECT") {
            selEl.value = value;
            selEl.dispatchEvent(new Event("change"));
          } else {
            selEl
              .querySelector('[value="' + value + '"]')
              .setAttribute("checked", "true");
          }
          this.mainButton.querySelector(".RevolutionSelectbox--Title").innerHTML =
            innerContent;
      
          if(this.element.classList.contains('dropdownSelector')){
            this.element.querySelector('.RevolutionSelectbox--Item[disabled="true"]').removeAttribute('disabled');
            event.target.setAttribute('disabled','true');      
          }
          this.closeDropdown(this.element);
        }
      
        onClickOutside(event) {
          const withinBoundaries = event.composedPath().includes(this.element);
          if (
            !withinBoundaries ||
            event.target.classList.contains("FiltersDesktopWrapper")
          ) {
            this.closeDropdown(this.element);
          }
        }
      
        selectboxSubmit(event) {
          if (event.key != "Enter" && event.key !== undefined) {
            return;
          }
          var value = event.target.getAttribute("data-value");
          var dataName = event.target.getAttribute("data-name");
          this.selectbox.value = value;
          this.closeDropdown(this.element);
          this.mainButton.querySelector(".RevolutionSelectbox--Title").innerHTML =
            dataName;
          this.selectbox.parentElement.submit();
        }
      
        initSelectbox() {
          const selectedItem = this.mainDropdown.querySelector('[selected="selected"]'),
            titleElement = this.element.querySelector(".RevolutionSelectbox--Title");
          if (selectedItem) {  
            titleElement.innerHTML = selectedItem.getAttribute("data-name");
            }
            
          this.element.style.display = "block";
        }
      
        toggleDropdown(event, target) {
          event.preventDefault();
      
      
          if (this.isOpen) {
            this.closeDropdown(target);
          } else {
            this.openDropdown(target);
          }
        }
      
        openDropdown(target) {
          // Dispatch "close:search" and "menu:close" events on the element.
          this.element.dispatchEvent(new CustomEvent('close:search', { bubbles: true }));
          this.element.dispatchEvent(new CustomEvent('menu:close', { bubbles: true }));
        
          // Find all siblings with class ".RevolutionSelectbox".
          const siblings = Array.from(target.parentElement.parentElement.children)
            .filter((item) => item.classList.contains('RevolutionSelectbox'));
        
          // Hide the dropdown content for all siblings.
          siblings.forEach((item) => {
            item.querySelector('.RevolutionSelectbox--Button').setAttribute('aria-expanded', false);
            item.querySelector('.RevolutionSelectbox--Content').setAttribute('aria-hidden', true);
            item.querySelector('.RevolutionSelectbox--Content').style.display = 'none';
          });
        
          // If the dropdown is a popover, show the page overlay and disable body scrolling.
          if (this.popover) {
            this.pageOverlayElement.classList.add('is-visible');
            this.pageOverlayElement.addEventListener('click', this.onClickOutsideListener);
            const focus = this.element.querySelector('[data-scrollable]');
            //document.html.classList.add('scrollLock');
           
            // if (document.querySelector('#Drawer').getAttribute('aria-expanded') === 'true') {
            //   document.querySelector('.Drawer--Wrapper').style.overflow = 'visible';
            // }
          }
        
          // Show the dropdown content for the target element and set its state to "expanded".
          const contentElement = target.parentElement.querySelector('.RevolutionSelectbox--Content');
          target.setAttribute('aria-expanded', 'true');
          contentElement.style.display = 'block';
          contentElement.style.height = `${contentElement.offsetHeight}px`;
      
          if (this.popover){
            setTimeout(() => {
              contentElement.setAttribute('aria-hidden', 'false');
            }, 20);
          } else {
              contentElement.setAttribute('aria-hidden', 'false');
          }
         
      
          this.isOpen = true;
          window.addEventListener('click', this.onClickOutsideListener);  
        }
      
        closeDropdown(target) {
          var closestDropdown = target.closest(".RevolutionSelectbox");
          if (closestDropdown === null) {
            var closestDropdown = target.querySelector(
              "[aria-expanded='true']"
            ).parentElement;
          }
          closestDropdown
            .querySelector(".RevolutionSelectbox--Button")
            .setAttribute("aria-expanded", false);
          closestDropdown
            .querySelector(".RevolutionSelectbox--Content")
            .setAttribute("aria-hidden", true);
          setTimeout(() => {
            closestDropdown.querySelector(
              ".RevolutionSelectbox--Content"
            ).style.display = "none";
          }, 300);
      
          if (this.popover == true) {
            this.pageOverlayElement.classList.remove("is-visible");
            this.pageOverlayElement.removeEventListener(
              "click",
              this.onClickOutsideListener
            );
      
            const menuDrawer = document.querySelector('.RevolutionSelectbox--Button');
            if(menuDrawer.getAttribute('aria-expanded') == "true"){
              document.querySelector('.Drawer--Wrapper').style.overflow = "auto";
            }else{
            
            }
            
           
          }
          this.isOpen = false;
          window.removeEventListener("click", this.onClickOutsideListener);
        }
      }


window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

    /**
     * For use when focus shifts to a container rather than a link
     * eg for In-page links, after scroll, focus shifts to content area so that
     * next `tab` is where user expects if focusing a link, just $link.focus();
     *
     * @param {JQuery} $element - The element to be acted upon
     */
    pageLinkFocus: function($element) {
        var focusClass = 'js-focus-hidden';

        $element.first()
            .attr('tabIndex', '-1')
            .focus()
            .addClass(focusClass)
            .one('blur', callback);

        function callback() {
            $element.first()
                .removeClass(focusClass)
                .removeAttr('tabindex');
        }
    },

    /**
     * If there's a hash in the url, focus the appropriate element
     */
    focusHash: function() {
        var hash = window.location.hash;

        // is there a hash in the url? is it an element on the page?
        if (hash && document.getElementById(hash.slice(1))) {
            this.pageLinkFocus($(hash));
        }
    },

    /**
     * When an in-page (url w/hash) link is clicked, focus the appropriate element
     */
    bindInPageLinks: function() {
        $('a[href*=#]').on('click', function(evt) {
            this.pageLinkFocus($(evt.currentTarget.hash));
        }.bind(this));
    },

    /**
     * Traps the focus in a particular container
     *
     * @param {object} options - Options to be used
     * @param {jQuery} options.$container - Container to trap focus within
     * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
     * @param {string} options.namespace - Namespace used for new focus event handler
     */
    // trapFocus: function(options) {
    //     var eventName = options.namespace ?
    //         'focusin.' + options.namespace :
    //         'focusin';

    //     if (!options.$elementToFocus) {
    //         options.$elementToFocus = options.$container;
    //     }

    //     options.$container.attr('tabindex', '-1');
    //     options.$elementToFocus.focus();

    //     $(document).on(eventName, function(evt) {
    //         if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
    //             options.$container.focus();
    //         }
    //     });
    // },

    /**
     * Removes the trap of focus in a particular container
     *
     * @param {object} options - Options to be used
     * @param {jQuery} options.$container - Container to trap focus within
     * @param {string} options.namespace - Namespace used for new focus event handler
     */
    // removeTrapFocus: function(options) {
    //     var eventName = options.namespace ?
    //         'focusin.' + options.namespace :
    //         'focusin';

    //     if (options.$container && options.$container.length) {
    //         options.$container.removeAttr('tabindex');
    //     }

    //     $(document).off(eventName);
    // }
};
/** Slideshow **/


/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {

    /**
     * Browser cookies are required to use the cart. This function checks if
     * cookies are enabled in the browser.
     */
    cookiesEnabled: function() {
        var cookieEnabled = navigator.cookieEnabled;

        if (!cookieEnabled) {
            document.cookie = 'testcookie';
            cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
        }
        return cookieEnabled;
    },

    updateQty: function(value, product) {
        if (cartQtyLock) return; // ako je request u toku, ignorisi klik

        cartQtyLock = true; // zakljucaj
        $('body').addClass('loading');

        $.post('/cart/change.js', { quantity: value, line: product }, function(data) {

            var newTotalPrice = slate.Currency.formatMoney(data.total_price, theme.moneyFormat);
            var newTotalQty = data.item_count;
            if (value == 0) {
                
                $('.js-cart-count span').html(newTotalQty);
                $('tr[data-product="' + product + '"').addClass('anim animated fadeOutRight').delay(500).queue(function() {
                    $(this).remove();

                    $('tr[data-product').each(function(i) {
                        $(this).attr('data-product', i + 1);
                    });

                    if (newTotalQty == 0) {
                        $('.cart--not-empty').hide();
                        $('.checkout__button').hide();
                        $('.cart--empty').show();
                        $('.js-cart-count span').hide();
                    }
                });

            } else {
                
                var newPrice = slate.Currency.formatMoney(data.items[product - 1].line_price, theme.moneyFormat),
                    newQty = data.items[product - 1].quantity;
                    
                $('tr[data-product="' + product + '"').find('.js-line-price').html(newPrice);
                $('tr[data-product="' + product + '"').find('input').val(newQty);
            }

            // if (value == newTotalQty)
            var $row = $('tr[data-product="' + product + '"]');

            $row.find('.js-stock-message').fadeOut(150);
            $row.find('.js-increase').prop('disabled', false).removeClass('is-disabled');


                $('.js-total-price').html(newTotalPrice);
            $('body').removeClass('loading');
            $('.js-cart-count span').html(data.item_count);

            cartQtyLock = false;
        }, "json").fail(function(xhr) {
            cartQtyLock = false;
            $('body').removeClass('loading');

            var $row = $('tr[data-product="' + product + '"]');
            var $plusBtn = $row.find('.js-increase');
            var $msg = $row.find('.js-stock-message');

            if (xhr.status === 422) {
                var text = xhr.responseJSON?.description || 'Proizvod trenutno nije dostupan u traženoj količini.';

                // prikaži poruku
                if (!$msg.length) {
                    $msg = $('<tr class="js-stock-message-row"><td colspan="100"><div class="js-stock-message stock-message"></div></td></tr>')
                    .insertAfter($row)
                    .find('.js-stock-message');

                }

                $msg.text(text).stop(true, true).fadeIn(200);

                // disable +
                $plusBtn.prop('disabled', true).addClass('is-disabled');

                setTimeout(function() {
                    $msg.fadeOut(300);
                }, 3000);

            } else {
                console.error('Cart update failed');
            }
        });

    }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

    /**
     * Return an object from an array of objects that matches the provided key and value
     *
     * @param {array} array - Array of objects
     * @param {string} key - Key to match the value against
     * @param {string} value - Value to get match of
     */
    findInstance: function(array, key, value) {
        for (var i = 0; i < array.length; i++) {
            if (array[i][key] === value) {
                return array[i];
            }
        }
    },

    /**
     * Remove an object from an array of objects by matching the provided key and value
     *
     * @param {array} array - Array of objects
     * @param {string} key - Key to match the value against
     * @param {string} value - Value to get match of
     */
    removeInstance: function(array, key, value) {
        var i = array.length;
        while (i--) {
            if (array[i][key] === value) {
                array.splice(i, 1);
                break;
            }
        }

        return array;
    },

    /**
     * _.compact from lodash
     * Remove empty/false items from array
     * Source: https://github.com/lodash/lodash/blob/master/compact.js
     *
     * @param {array} array
     */
    compact: function(array) {
        var index = -1;
        var length = array == null ? 0 : array.length;
        var resIndex = 0;
        var result = [];

        while (++index < length) {
            var value = array[index];
            if (value) {
                result[resIndex++] = value;
            }
        }
        return result;
    },

    /**
     * _.defaultTo from lodash
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
     *
     * @param {*} value - Value to check
     * @param {*} defaultValue - Default value
     * @returns {*} - Returns the resolved value
     */
    defaultTo: function(value, defaultValue) {
        return (value == null || value !== value) ? defaultValue : value
    }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
    /**
     * Wrap tables in a container div to make them scrollable when needed
     *
     * @param {object} options - Options to be used
     * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
     * @param {string} options.tableWrapperClass - table wrapper class name
     */
    wrapTable: function(options) {
        var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

        options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
    },

    /**
     * Wrap iframes in a container div to make them responsive
     *
     * @param {object} options - Options to be used
     * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
     * @param {string} options.iframeWrapperClass - class name used on the wrapping div
     */
    wrapIframe: function(options) {
        var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

        options.$iframes.each(function() {
            // Add wrapper to make video responsive
            $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');

            // Re-set the src attribute on each iframe after page load
            // for Chrome's "incorrect iFrame content on 'back'" bug.
            // https://code.google.com/p/chromium/issues/detail?id=395791
            // Need to specifically target video and admin bar
            this.src = this.src;
        });
    }
};

slate.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];

    $(document)
        .on('shopify:section:load', this._onSectionLoad.bind(this))
        .on('shopify:section:unload', this._onSectionUnload.bind(this))
        .on('shopify:section:select', this._onSelect.bind(this))
        .on('shopify:section:deselect', this._onDeselect.bind(this))
        .on('shopify:section:reorder', this._onReorder.bind(this))
        .on('shopify:block:select', this._onBlockSelect.bind(this))
        .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
    _createInstance: function(container, constructor) {
        var $container = $(container);
        var id = $container.attr('data-section-id');
        var type = $container.attr('data-section-type');

        constructor = constructor || this.constructors[type];

        if (typeof constructor === 'undefined') {
            return;
        }

        var instance = $.extend(new constructor(container), {
            id: id,
            type: type,
            container: container
        });

        this.instances.push(instance);
    },

    _onSectionLoad: function(evt) {
        var container = $('[data-section-id]', evt.target)[0];
        if (container) {
            this._createInstance(container);
        }
    },

    _onSectionUnload: function(evt) {
        var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

        if (!instance) {
            return;
        }

        if (typeof instance.onUnload === 'function') {
            instance.onUnload(evt);
        }

        this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
    },

    _onSelect: function(evt) {
        var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

        if (instance && typeof instance.onSelect === 'function') {
            instance.onSelect(evt);
        }
    },

    _onDeselect: function(evt) {
        var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

        if (instance && typeof instance.onDeselect === 'function') {
            instance.onDeselect(evt);
        }
    },

    _onReorder: function(evt) {
        var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

        if (instance && typeof instance.onReorder === 'function') {
            instance.onReorder(evt);
        }
    },

    _onBlockSelect: function(evt) {
        var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

        if (instance && typeof instance.onBlockSelect === 'function') {
            instance.onBlockSelect(evt);
        }
    },

    _onBlockDeselect: function(evt) {
        var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

        if (instance && typeof instance.onBlockDeselect === 'function') {
            instance.onBlockDeselect(evt);
        }
    },

    register: function(type, constructor) {
        this.constructors[type] = constructor;

        $('[data-section-type=' + type + ']').each(function(index, container) {
            this._createInstance(container, constructor);
        }.bind(this));
    }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
    var moneyFormat = '${{amount}}';

    /**
     * Format money values based on your shop currency settings
     * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
     * or 3.00 dollars
     * @param  {String} format - shop money_format setting
     * @return {String} value - formatted value
     */
    function formatMoney(cents, format) {
        if (typeof cents === 'string') {
            cents = cents.replace('.', '');
        }
        var value = '';
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var formatString = (format || moneyFormat);

        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = slate.utils.defaultTo(precision, 2);
            thousands = slate.utils.defaultTo(thousands, ',');
            decimal = slate.utils.defaultTo(decimal, '.');

            if (isNaN(number) || number == null) {
                return 0;
            }

            number = (number / 100.0).toFixed(precision);

            var parts = number.split('.');
            var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
            var centsAmount = parts[1] ? (decimal + parts[1]) : '';

            return dollarsAmount + centsAmount;
        }

        switch (formatString.match(placeholderRegex)[1]) {
            case 'amount_with_comma_separator':
                value = formatWithDelimiters(cents, 2, ',', '.');
                break;
            case 'amount':
                value = formatWithDelimiters(cents, 2);
                break;
            case 'amount_no_decimals':
                value = formatWithDelimiters(cents, 0);
                break;
            case 'amount_with_space_separator':
                value = formatWithDelimiters(cents, 2, ' ', '.');
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(cents, 0, ',', '.');
                break;
            case 'amount_no_decimals_with_space_separator':
                value = formatWithDelimiters(cents, 0, ' ');
                break;
        }

        return formatString.replace(placeholderRegex, value);
    }

    return {
        formatMoney: formatMoney
    };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

    /**
     * Preloads an image in memory and uses the browsers cache to store it until needed.
     *
     * @param {Array} images - A list of image urls
     * @param {String} size - A shopify image size attribute
     */

    function preload(images, size) {
        if (typeof images === 'string') {
            images = [images];
        }

        for (var i = 0; i < images.length; i++) {
            var image = images[i];
            this.loadImage(this.getSizedImageUrl(image, size));
        }
    }

    /**
     * Loads and caches an image in the browsers cache.
     * @param {string} path - An image url
     */
    function loadImage(path) {
        new Image().src = path;
    }

    /**
     * Find the Shopify image attribute size
     *
     * @param {string} src
     * @returns {null}
     */
    function imageSize(src) {
        var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

        if (match) {
            return match[1];
        } else {
            return null;
        }
    }

    /**
     * Adds a Shopify size attribute to a URL
     *
     * @param src
     * @param size
     * @returns {*}
     */
    function getSizedImageUrl(src, size) {
        if (size === null) {
            return src;
        }

        if (size === 'master') {
            return this.removeProtocol(src);
        }

        var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

        if (match) {
            var prefix = src.split(match[0]);
            var suffix = match[0];

            return this.removeProtocol(prefix[0] + '_' + size + suffix);
        } else {
            return null;
        }
    }

    function removeProtocol(path) {
        return path.replace(/http(s)?:/, '');
    }

    return {
        preload: preload,
        loadImage: loadImage,
        imageSize: imageSize,
        getSizedImageUrl: getSizedImageUrl,
        removeProtocol: removeProtocol
    };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

    /**
     * Variant constructor
     *
     * @param {object} options - Settings from `product.js`
     */
    function Variants(options) {
        this.$container = options.$container;
        this.product = options.product;
        this.singleOptionSelector = options.singleOptionSelector;
        this.originalSelectorId = options.originalSelectorId;
        this.enableHistoryState = options.enableHistoryState;
        this.currentVariant = this._getVariantFromOptions();
        $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));



    }

    Variants.prototype = $.extend({}, Variants.prototype, {

        /**
         * Get the currently selected options from add-to-cart form. Works with all
         * form input elements.
         *
         * @return {array} options - Values of currently selected variants
         */
        _getCurrentOptions: function() {
            var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
                var $element = $(element);
                var type = $element.attr('type');
                var currentOption = {};

                if (type === 'radio' || type === 'checkbox') {
                    if ($element[0].checked) {
                        currentOption.value = $element.val();
                        currentOption.index = $element.data('index');

                        if (currentOption.value.includes(' - ')) {
                            currentOption.value = currentOption.value.split(' - ')[0].trim();
                        }

                        return currentOption;
                    } else {
                        return false;
                    }
                } else {
                    currentOption.value = $element.val();
                    currentOption.index = $element.data('index');
                    if (currentOption.value.includes(' - ')) {
                        currentOption.value = currentOption.value.split(' - ')[0].trim();
                    }

                    const selected = $(':selected', $element)[0];
                    if (selected) {
                        currentOption.event = selected.dataset.event;
                    }
                                                
                    console.log('Čista vrednost:', currentOption.value);
                    console.log(currentOption)
                    if(currentOption.event != 'trigger-selector'){
                      return currentOption;
                    }

                }
            });

            // remove any unchecked input values if using radio buttons or checkboxes
            currentOptions = slate.utils.compact(currentOptions);

            return currentOptions;
        },

        /**
         * Find variant based on selected values.
         *
         * @param  {array} selectedValues - Values of variant inputs
         * @return {object || undefined} found - Variant object from product.variants
         */
        _getVariantFromOptions: function() {
            var selectedValues = this._getCurrentOptions();

            var variants = this.product.variants;
            var found = false;

            variants.forEach(function(variant) {
                var satisfied = true;

                selectedValues.forEach(function(option) {

                    if (satisfied) {
                        satisfied = (option.value === variant[option.index]);

                    }
                });

                if (satisfied) {
                    found = variant;
                }
            });

            return found || null;
        },

        /**
         * Event handler for when a variant input changes.
         */
        _onSelectChange: function() {

          var variant = this._getVariantFromOptions();

       var actionMethod = $(event.target).find(':selected').attr('data-action');
       if(actionMethod){
         $("[data-action='openSize']").unbind();
         var id = $(event.target).find(':selected').attr('data-value');
          //$('#SI_trigger').click();
          clearInterval(window.interval);
            if($.trim($('.atcBUTTON > span').text()) != "COMING SOON"){
                $('.atcBUTTON > span').html('NOTIFY ME');
            }

                $('#variants').val(id).change();
                $('.atcBUTTON').removeAttr('data-add-to-cart');
                $('.atcBUTTON').removeAttr('data-action');
                $('.atcBUTTON').removeAttr('disabled');
                $('.atcBUTTON').removeAttr('onclick');
                $('.atcBUTTON').addClass('notifyOpen');
                $('.atcBUTTON').removeClass('js-add-cart');

                $('.notifyOpen').unbind("click").on('click', function(event) { 
                     event.preventDefault();
                    // $('.SI_trigger').click();
                    if($(this).hasClass("notifyOpen")) {
                        $('.gw-float-widget').click();
                    } else {
                        
                    }
                });
            }
           
            this.$container.trigger({
                type: 'variantChange',
                variant: variant
            });

            if (!variant) {
                return;
            }

            this._updateMasterSelect(variant);
            this._updateImages(variant);
            this._updatePrice(variant);
            this.currentVariant = variant;

            if (this.enableHistoryState) {

                this._updateHistoryState(variant);
            }
        },

        /**
         * Trigger event when variant image changes
         *
         * @param  {object} variant - Currently selected variant
         * @return {event}  variantImageChange
         */
        _updateImages: function(variant) {
            var variantImage = variant.featured_image || {};
            var currentVariantImage = this.currentVariant.featured_image || {};

            if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
                return;
            }

            this.$container.trigger({
                type: 'variantImageChange',
                variant: variant
            });
        },

        /**
         * Trigger event when variant price changes.
         *
         * @param  {object} variant - Currently selected variant
         * @return {event} variantPriceChange
         */
        _updatePrice: function(variant) {
            if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
                return;
            }

            this.$container.trigger({
                type: 'variantPriceChange',
                variant: variant
            });
        },

        /**
         * Update history state for product deeplinking
         *
         * @param {object} variant - Currently selected variant
         */
        _updateHistoryState: function(variant) {

            if (!history.replaceState || !variant) {
                return;
            }

            var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
            window.history.replaceState({ path: newurl }, '', newurl);
        },

        /**
         * Update hidden master select of variant change
         *
         * @param {object} variant - Currently selected variant
         */
        _updateMasterSelect: function(variant) {
            $(this.originalSelectorId, this.$container)[0].value = variant.id;
        }
    });

    return Variants;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

theme.Product = (function() {

    var selectors = {
        addToCart: '[data-add-to-cart]',
        addToCartText: '[data-add-to-cart-text]',
        comparePrice: '[data-compare-price]',
        comparePriceText: '[data-compare-text]',
        originalSelectorId: '[data-product-select]',
        priceWrapper: '[data-price-wrapper]',
        productFeaturedImage: '[data-product-featured-image]',
        productJson: '[data-product-json]',
        productPrice: '[data-product-price]',
        productThumbs: '[data-product-single-thumbnail]',
        singleOptionSelector: '[data-single-option-selector]'
    };

    /**
     * Product section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     * @param {string} container - selector for the section container DOM element
     */
    function Product(container) {
        this.$container = $(container);

        // Stop parsing if we don't have the product json script tag when loading
        // section in the Theme Editor
        if (!$(selectors.productJson, this.$container).html()) {
            return;
        }



        var container_1 = container;

        $('.prod-image-slider').on('init', function(event, slick){
          var width = $(window).width();
          var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ? true : width < 1025;
          if(isMobile){
            var userHeight = window.innerHeight;
              var imageHeight = $('.product-images__image').height();
              var headerHeight = $('#shopify-section-header').height() + 20;
              var annHeight = $('#shopify-section-announcement').height();
              var treshold = userHeight - imageHeight;
              var mobileMenu = $('.product_mobile_menu').height();
              var translateValue = userHeight - imageHeight - headerHeight - annHeight;
              if(translateValue < 0){
                var newTranslate =  mobileMenu + 30;
              }else{
                var newTranslate = translateValue + mobileMenu + 23;
              }

              console.log(newTranslate);



              $(window).scroll(function() {

    if($(window).scrollTop() >= treshold || translateValue > mobileMenu)
    {
      $('.product_mobile_menu').css('transform', "translateY(0px)");
    }else{

      $('.product_mobile_menu').css('transform', "translateY("+newTranslate+"px)");
    }

     })

     $( window ).resize(function() {
       if($(window).scrollTop() >= treshold || translateValue > mobileMenu)
       {
         $('.product_mobile_menu').css('transform', "translateY(0px)");
       }else{

         $('.product_mobile_menu').css('transform', "translateY("+newTranslate+"px)");
       }
     });

          }

         $( "[data-action='change-slide']").on( "click", function() {
           slider.slick('slickGoTo', $(this).attr('data-slide'));

 });


     $('.play_video_button').click(function() {

      slider.slick('slickGoTo',  $('.video-wrapper').data('slide'));

             $('.product-video').trigger('play');
         });



 var width = $(window).width();
 var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ? true : width < 1025;

 if(window.innerWidth < 1025){
    
    var allImages = container_1.querySelectorAll('.mySlides');
    allImages.forEach((image) => {
        new PinchZoom.default(image, {});
       })
   } else {
    
    var allImages = container_1.querySelectorAll('.zoomIMG');
    allImages.forEach((item, i) => {
        $(item).zoom(
          {
            on: "click",
            magnify: 1.6
          }
        );
      });
   }


   window.addEventListener('resize', function(event) {
   container.querySelector('.prod-image-thumb').style.height = $('.mySlides').outerHeight() + "px";
 }, true);
container.querySelector('.prod-image-thumb').style.height = slick.listHeight + "px";




        });
        var slider =$('.prod-image-slider').slick({
          dots: false,
          infinite: true,
          slidesToShow: 1,
          draggable: false,
          touchMove: false,
          arrows: true,
          nextArrow: "<button type='button' class='product-next'>Next</button>",
          prevArrow: "<button type='button' class='product-prev'>Next</button>"
        });
      slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){

      if($('[data-slick-index="'+nextSlide+'"] .video-wrapper').length > 0){

         $('.product-video').trigger('play');

      }
    });
    slider.on('swipe', function(event, slick, direction){
      var currentSlide = slider.slick('slickCurrentSlide');

      if($('[data-slick-index="'+currentSlide+'"] .video-wrapper').length > 0){
         $('.product-video').trigger('play');

      }
});
    var combiSlider = $('.pp-style_slider').slick({
      infinite: true,
      slidesToShow: 3,
      centerMode: true,
      centerPadding: '0px',
      responsive: [
      {
        breakpoint: 967,
        settings: {

          centerMode: true,
          centerPadding: '0px',
          slidesToShow: 2
          }
        },
        {
        breakpoint: 770,
        settings: {
          arrows: true,
          centerPadding: '0px',
          centerMode: false,
          slidesToShow: 2
        }
        }
        ]
    });

    var styleWithSlider = $('.styleWith-style_slider').slick({
        infinite: false,
        slidesToShow: 4,
        centerMode: true,
        centerPadding: '0px',
        responsive: [
        {
          breakpoint: 967,
          settings: {
  
            centerMode: true,
            centerPadding: '0px',
            slidesToShow: 2
            }
          },
          {
          breakpoint: 770,
          settings: {
            arrows: true,
            centerPadding: '0px',
            centerMode: false,
            slidesToShow: 2
          }
          }
          ]
      });

        var sectionId = this.$container.attr('data-section-id');
        this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());
        var dropbox = container.querySelectorAll('.RevolutionDropdown');
        if (dropbox !== null){
          dropbox.forEach((item, i) => {
              new RevolutionSelectbox(item);
          });


        }

        var options = {
            $container: this.$container,
            enableHistoryState: this.$container.data('enable-history-state') || false,
            singleOptionSelector: selectors.singleOptionSelector,
            originalSelectorId: selectors.originalSelectorId,
            product: this.productSingleObject
        };

        this.settings = {};
        this.namespace = '.product';
        this.variants = new slate.Variants(options);

        this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

        this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
        this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

        if (this.$featuredImage.length > 0) {
            this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
            slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

            this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
        }
    }



    Product.prototype = $.extend({}, Product.prototype, {

        /**
         * Updates the DOM state of the add to cart button
         *
         * @param {boolean} enabled - Decides whether cart is enabled or disabled
         * @param {string} text - Updates the text notification content of the cart
         */
        changeSlide: function(evt) {
            console.log(evt);
        },

        updateAddToCartState: function(evt) {

          var variant = evt.variant;
            console.log(variant)
          if (variant) {
              $(selectors.priceWrapper, this.$container).removeClass('hide');
          } else {
              $(selectors.addToCart, this.$container).prop('disabled', true);
            $(selectors.addToCartText, this.$container).html(theme.strings.notify);
              $(selectors.priceWrapper, this.$container).addClass('hide');
              return;
          }

          if (event.target.dataset.event == 'trigger-selector') {
            console.log('test 1')
                        var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ? true : width < 1025;
            $(".notifyOpen").unbind();
            $('.atcBUTTON').attr('data-action','openSize');
            console.log('here');
            $('.atcBUTTON').removeClass('js-add-cart');
            $('.atcBUTTON').removeClass('notifyOpen');
                  if(!isMobile){
              $('.atcBUTTON').css({"color":"black","background":"white"});
            }
                  if($.trim($('.atcBUTTON > span').text()) != "COMING SOON"){
                  $('.atcBUTTON > span').html("ADD TO BAG");
              }
                  $('.atcBUTTON').prop('disabled', false);
            $( "[data-action='openSize']").on( "click", function() {
              event.preventDefault();
                $('.atcBUTTON > span').html("PLEASE SELECT SIZE");
        });

      if($.trim($('.atcBUTTON > span').text()) != "COMING SOON"){
              $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
              }

            clearInterval(window.interval);
          }
          else if (variant.available) {
           
            var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ? true : width < 1025;
            $("[data-action='openSize']").unbind();
                
            $('.atcBUTTON').removeClass('notifyOpen');
                        if(!isMobile){
              $('.atcBUTTON').css({"color":"white","background":"black"});
            }

            let preview = document.querySelector('.dataPreview').getAttribute('data-preview');
            if (preview == 'true'){
               
            }else{
                
                if(event.target.selectedIndex === 0){
                    $('.atcBUTTON').removeClass('js-add-cart');
                    $('.atcBUTTON').removeAttr('data-add-to-cart');
                    $('.atcBUTTON').attr('openSize','true');
                    $('.atcBUTTON').attr('disabled', 'true');
                } else {
                    $('.atcBUTTON').removeAttr('openSize');
                    $('.atcBUTTON').removeAttr('disabled');  
                    $('.atcBUTTON').addClass('js-add-cart');
                    $('.atcBUTTON').attr('data-add-to-cart','true');
                           
                }
                
                // $("[data-action='openSize']").on( "click", function() {
                //     event.preventDefault();
                //       $('.atcBUTTON > span').html("PLEASE SELECT SIZE");
                // });
                
            }

             
            $('.atcBUTTON').removeAttr('data-action');
            $('.atcBUTTON').removeAttr('onclick');
            var width = $(window).width();

            if(!isMobile){
                  $(selectors.addToCart, this.$container).css({"color":"white","background":"black"});
            }
              $(selectors.addToCart, this.$container).prop('disabled', false);
      var inventoryQuantity = $('#info--'+variant.id).attr('data-quantity');

            if(inventoryQuantity > 5){
      if($.trim($('.atcBUTTON > span').text()) != "COMING SOON"){
              $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
    }

             clearInterval(window.interval);
            }else{

              $(function () {
                  clearInterval(window.interval);
$(selectors.addToCartText, this.$container).html(theme.strings.lowInStock);
count = 0;
wordsArray = [theme.strings.lowInStock, theme.strings.addToCart];
window.interval = setInterval(function () {
  count++;

  $(selectors.addToCartText, this.$container).fadeOut(300, function () {
    $(this).text(wordsArray[count % wordsArray.length]).fadeIn(300);
  });
}, 2000);
});

            }

          } else {
            var width = $(window).width();
            var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ? true : width < 1025;
            if(!isMobile){
                $(selectors.addToCart, this.$container).css({"color":"black","background":"white"});
            }

              $(selectors.addToCart, this.$container).prop('disabled', true);
              $(selectors.addToCartText, this.$container).html(theme.strings.notify);
          }

        },


        /**
         * Updates the DOM with specified prices
         *
         * @param {string} productPrice - The current price of the product
         * @param {string} comparePrice - The original price of the product
         */
        updateProductPrices: function(evt) {
            var variant = evt.variant;
            var $comparePrice = $(selectors.comparePrice, this.$container);
            var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

            $(selectors.productPrice, this.$container)
                .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

            if (variant.compare_at_price > variant.price) {
                $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
                $compareEls.removeClass('hide');
            } else {
                $comparePrice.html('');
                $compareEls.addClass('hide');
            }
        },

        /**
         * Updates the DOM with the specified image URL
         *
         * @param {string} src - Image src URL
         */
        updateProductImage: function(evt) {
            var variant = evt.variant;
            var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

            this.$featuredImage.attr('src', sizedImgUrl);
        },

        /**
         * Event callback for Theme Editor `section:unload` event
         */
        onUnload: function() {
            this.$container.off(this.namespace);
        }
    });

    return Product;
})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
    var $newAddressForm = $('#AddressNewForm');

    if (!$newAddressForm.length) {
        return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
        new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
            hideElement: 'AddressProvinceContainerNew'
        });
    }

    // Initialize each edit form's country/province selector
    $('.address-country-option').each(function() {
        var formId = $(this).data('form-id');
        var countrySelector = 'AddressCountry_' + formId;
        var provinceSelector = 'AddressProvince_' + formId;
        var containerSelector = 'AddressProvinceContainer_' + formId;

        new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
            hideElement: containerSelector
        });
    });

    // Toggle new/edit address forms
    $('.address-new-toggle').on('click', function() {
        $newAddressForm.toggleClass('hide');
    });

    $('.address-edit-toggle').on('click', function() {
        var formId = $(this).data('form-id');
        $('#EditAddress_' + formId).toggleClass('hide');
    });

    $('.address-delete').on('click', function() {
        var $el = $(this);
        var formId = $el.data('form-id');
        var confirmMessage = $el.data('confirm-message');
        if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
            Shopify.postLink('/account/addresses/' + formId, { parameters: { _method: 'delete' } });
        }
    });
})();

class Responsive {
    constructor() {
        var _this = this;

        this.currentBreakpoint = this.getCurrentBreakpoint();

        window.addEventListener("resize", function () {
            var newBreakpoint = _this.getCurrentBreakpoint();

            if (_this.currentBreakpoint === newBreakpoint) {
                return;
            }

            document.dispatchEvent(
                new CustomEvent("breakpoint:changed", {
                    detail: {
                        previousBreakpoint: _this.currentBreakpoint,
                        currentBreakpoint: newBreakpoint,
                    },
                })
            );

            _this.currentBreakpoint = newBreakpoint;
        });
    }

    matchesBreakpoint(breakpoint) {
        switch (breakpoint) {
            case "phone":
                return window.matchMedia("screen and (max-width: 640px)").matches;

            case "tablet":
                return window.matchMedia(
                    "screen and (min-width: 641px) and (max-width: 1024px)"
                ).matches;

            case "tablet-and-up":
                return window.matchMedia("screen and (min-width: 768px)").matches;

            case "pocket":
                return window.matchMedia("screen and (max-width: 1024px)").matches;

            case "lap-and-up":
                return window.matchMedia("screen and (min-width: 1024px)").matches;

            case "desk":
                return window.matchMedia("screen and (min-width: 1280px)").matches;

            case "widescreen":
                return window.matchMedia("screen and (min-width: 1600px)").matches;
        }
    }
    getCurrentBreakpoint() {
        if (window.matchMedia("screen and (max-width: 640px)").matches) {
            return "phone";
        }

        if (
            window.matchMedia("screen and (min-width: 641px) and (max-width: 1024px)")
                .matches
        ) {
            return "tablet";
        }

        if (
            window.matchMedia(
                "screen and (min-width: 1008px) and (max-width: 1279px)"
            ).matches
        ) {
            return "lap";
        }

        if (window.matchMedia("screen and (min-width: 1280px)").matches) {
            return "desk";
        }
    }
}
class RevolutionSwiper {
    constructor(element, additionalSwiper) {
        var options =
            arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.element = element;
        this.thumb = additionalSwiper;
        this.initialConfig = JSON.parse(
            element.getAttribute("data-swiper-settings")
        );

        if (additionalSwiper) {
            this.initialConfigThumbs = JSON.parse(
                additionalSwiper.getAttribute("data-swiper-thumb-settings")
            );
        }
        this.options = options;
        this.build();
    }

    destroy() {
        this.swiperElement.destroy();
    }

    selectCell(index) {


        this.swiperElement.slideTo(index);
    }

    resize() {
        this.swiperElement.resize();
    }


    build() {
        var _this = this;

        var configThumb = this.initialConfigThumbs;
        if (configThumb != null) {
            this.thumbSwiper = new Swiper(this.thumb, configThumb);
            this.initialConfig.thumbs["swiper"] = this.thumbSwiper;
        }


        this.swiperElement = new Swiper(this.element, this.initialConfig);
        this.selectedIndex = this.swiperElement.activeIndex;

        this.swiperElement.on('slideChange', function () {
            _this.element.dispatchEvent(
                new CustomEvent("slideChangeD", {
                    bubbles: true,
                    detail: {
                        currentIndex: _this.swiperElement.activeIndex,
                        element: _this.swiperElement.$el[0]
                    }

                })
            );
        });

    }
}


class SearchBar extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.searchElement = this;
        this.delegateElement = new Delegate(this.element);
        this.searchInputElement = this.element.querySelector('[name="q"]');
        this.queryMap = {};
        this.searchResultsElement = this.element.querySelector(".SearchInitial");
        this.pageOverlayElement = document.querySelector(".pageOverlay");
        this.options = JSON.parse(this.element.getAttribute("data-settings"));
        this.srValue = "";
        this.initialSearchLayout = this.searchResultsElement.cloneNode(true);
        if (window.theme.showRecentSearches) { this.getRecentSearches(); }
        this.carouselElement = this.element.querySelector('.SearchCollection--NoResults');
        if (this.carouselElement) {
            if (new Responsive().matchesBreakpoint('lap-and-up')) {
                this.carousel = new RevolutionSwiper(this.carouselElement);
            }
        }


        if (window.theme.enableAnimations) { this.timeline = new TimelineLite({ delay: 0.6 }); this.setupAnimation(); }

        this.bindEvents();
    }

    bindEvents() {
      var _this = this;
        this._preventSubmissionListener = this.preventSubmission.bind(this);
        this._onInputListener = this.debounce(this.onInput.bind(this), 450);
        this._closeListener = this.closeSearch.bind(this);
        this.delegateElement.on(
            "click",
            '[data-action="open-search"]',
            this.openSearch.bind(this)
        );
        this.delegateElement.on(
            "click",
            '[data-action="close-search"]',
            this.closeSearch.bind(this)
        );
        this.delegateElement.on(
            "keydown",
            '[data-action="close-search"]',
            this.closeSearch.bind(this)
        );
        this.searchInputElement.addEventListener(
            "keydown",
            this._preventSubmissionListener
        );
        this.searchInputElement.addEventListener("input", this._onInputListener);

        document.addEventListener("mobile-menu:open", this.closeSearch.bind(this));
        document.addEventListener("favorite-product:open", this.closeSearch.bind(this));
        document.addEventListener("cart-drawer:open", this.closeSearch.bind(this));

        this.delegateElement.on(
            "click",
            '[data-action="search-string"]',
            this.onInput.bind(this)
        );
        this.delegateElement.on(
            "click",
            '[data-action="active-filters"]',
            this.onSubmitHandler.bind(this)
        );
        this.delegateElement.on(
            "click",
            '[data-action="reset-recent"]',
            this.resetRecent.bind(this)
        );

        this.delegateElement.on(
            "click",
            '[data-action="remove-all"]',
            this.resetFilter.bind(this)
        );
        this.delegateElement.on(
            "click",
            '[data-action="toggle-filter"]',
            this.toggleFilters.bind(this)
        );
        $( ".triggerNewSearch" ).click(function() {
          _this.openSearch();
        });
    }
    toggleFilters(){
        event.target.classList.toggle('isOpen');
        this.element.querySelector('.FiltersWrapper').classList.toggle('FilterOpen');
    }

    resetFilter(){
      this.element.querySelectorAll('input').forEach((item, i) => {
        item.checked = false;
      });
  const searchParams = $('#FacetFiltersForm').serialize();
      this.renderPage(searchParams)
    }


resetRecent(){
    localStorage.removeItem('searchTerms');
    this.getRecentSearches();
}
    onSubmitHandler(event) {
  event.preventDefault();

  const searchParams = $(event.target.closest('form')).serialize();

 this.renderPage(searchParams, event);
}


    renderPage(searchParams, event){
       this.lastInputValue = this.element.querySelector('.SearchInput').value;

      var queryOptions = {
          method: "GET",
          credentials: "same-origin",
      };

      var queries = [
          fetch(
              "/search?view=ajax&q=" +
              encodeURIComponent(this.lastInputValue) +
              "*&type=product&" + searchParams ,
              queryOptions
          ),
      ];
      var _this = this;
      Promise.all(queries).then(function (responses) {
          console.log(responses);
          Promise.all(
              responses.map(function (response) {
                  return response.text();
              })
          ).then(function (contents) {


              if (window.theme.searchMode === "product") {
                  var searchResult = '<div class="SearchLayoutSingle">\n<div class="SearchLayout__Section SearchLayout__Section--Products">' +
                  contents[0] +
                  '</div>\n';

              }
              
            
                _this.searchResultsElement.innerHTML = contents;
              
          });
      });


    }


    initCarousel() {

        if (new Responsive().matchesBreakpoint('lap-and-up')) {
            var carousel = this.searchResultsElement.querySelector('.swiper');
            this.newCarousel = new RevolutionSwiper(carousel);

        }

    }

    debounce(fn, delay) {
        var _this0 = this;

        var timer = null;

        return function () {
            for (
                var _len = arguments.length, args = Array(_len), _key = 0;
                _key < _len;
                _key++
            ) {
                args[_key] = arguments[_key];
            }

            clearTimeout(timer);

            timer = setTimeout(function () {
                fn.apply(_this0, args);
            }, delay);
        };
    }

    setupAnimation() {
        var _this = this;
        if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
        }
        this.intersectionObserver = new IntersectionObserver(
            this.reveal.bind(this),
            {
                threshold: 0.2,
            }
        );

        new DomHelper()
            .nodeListToArray(this.element.querySelectorAll(".SearchSlide"))
            .forEach(function (item) {
                _this.intersectionObserver.observe(item);
            });
    }


    reveal(results) {
        var _this34 = this;

        var toReveal = [];

        results.forEach(function (result) {
            if (result.isIntersecting || result.intersectionRatio > 0) {
                // isIntersecting does not exist on Samsung Android browser
                toReveal.push(result.target);
                _this34.intersectionObserver.unobserve(result.target);
            }
        });

        if (toReveal.length === 0) {
            return;
        }

        this.timeline.staggerFromTo(
            toReveal,
            0.25,
            { autoAlpha: 0, y: 25 },
            { autoAlpha: 1, y: 0 },
            0.25
        );
    }

    openSearch() {
        event.preventDefault();

        const _this = this;

        const searchWrapper = this.element.querySelector(".SearchWrapper");
        this.pageOverlayElement.classList.add('is-visible');

        searchWrapper.style.display = "flex";
        requestAnimationFrame(() => {
            searchWrapper.setAttribute("aria-hidden", false);
            $('.menu,.js-menu-trigger').removeClass('open');
            $('.menu').attr('aria-hidden', 'true');
        })

        // add bodyscrolllock
        document.body.style.position = "fixed";
        document.body.style.width = "100%";

        if (_this.options['transparent']) {
            requestAnimationFrame(() => {
                const header = document.body.querySelector('#header');
                header?.classList.remove('Header--Transparent');
            })
        }

        requestAnimationFrame(() => {
            setTimeout(() => {
                const headerEl = document.body.querySelector('.main-header');
                const announcementEl = document.body.querySelector('.announcement-bar');

                const headerHeight = headerEl ? headerEl.getBoundingClientRect().height : 0;
                const announcementHeight =
                    announcementEl && window.getComputedStyle(announcementEl).display !== 'none'
                    ? announcementEl.getBoundingClientRect().height
                    : 0;

                const topOffset = headerHeight + announcementHeight - 1;

                if (searchWrapper) {
                    searchWrapper.style.top = `${topOffset}px`;
                }
            }, 200);

            document.documentElement.style.setProperty('--search-input-height', document.querySelector('.SearchInput--Wrapper').offsetHeight+"px");
        });

        const searchInput = this.element.querySelector('.SearchInput');
        if (searchInput) {
            searchInput.value = '';
            searchInput.focus();
        }

        this.closeDrawers();

        _this.closeListener = _this.closeSearch.bind(this);
        this.pageOverlayElement.addEventListener("click", _this.closeListener);
    }

    closeDrawers(){
        let drawers = document.querySelectorAll('.drawer');
        let drawerWrappers = document.querySelectorAll('.Drawer--wrapper');
        let cart = document.querySelector('.cart');
        drawers.forEach((drawer) => {
            if(drawer.classList.contains('open')){
                drawer.classList.remove('open');
            }
        });
        drawerWrappers.forEach((drawerWrapper) => {
            let drawerExpanded = drawerWrapper.getAttribute('aria-expanded');
            if (drawerExpanded == 'true'){
                document.dispatchEvent(
                    new CustomEvent("favorite-drawer:close", {
                      bubbles: true,
                    })
                )
            }
            
        });

        if(cart.classList.contains('open')){
            cart.classList.remove('open');
        }
        
    }

    closeSearch() {
        event.preventDefault();
        var _this = this;

        const searchWrapper = this.element.querySelector(".SearchWrapper[aria-hidden='false']");
        if (!searchWrapper) return;

        this.pageOverlayElement.removeEventListener("click", this._closeListener);
        this.pageOverlayElement.classList.remove('is-visible');

        searchWrapper.setAttribute("aria-hidden", true);
        searchWrapper.style.height = "auto";

        setTimeout(() => {
            searchWrapper.style.display = "none";
        }, 300);

        const header = document.body.querySelector("#shopify-section-header");
        header.style.backgroundColor = "transparent";

        document.body.style.position = "relative";
        document.body.style.width = "100%";

        this.resetSearch();
        if (_this.options['transparent']) { 
            document.body.querySelector('#header').classList.add('Header--Transparent'); 
        }
    }

    preventSubmission(event) {
        if (event.keyCode === 13 && window.theme.searchMode !== "product") {
            event.preventDefault();
        }
    }

    createLinkElement(item) {
        const a = document.createElement("a");
        a.className = "stylein--live u-p5_new";

        const title = item.pageName || item.metaPage || item.title;
        const url = item.pageLink || item.metaLink || item.url;

        a.href = url;
        a.textContent = title;

        return a;
    }

    // vraća HTML za linkove koji match-uju input
    createLinks(list, inputValue) {
        if (!Array.isArray(list)) return "";

        let html = "";
        list.forEach(item => {
            const s = (item.searchString || item.metaPage || "").toLowerCase();
            if (s === inputValue) {
                html += `
                    <a href="${item.pageLink || item.metaLink}" class="stylein--live u-p5_new">
                        ${item.pageName || item.metaPage}
                    </a>`;
            }
        });

        return html;
    }

    async handleSearchResponses(responses, event, passTrough) {
        var _this = this;
        // If we receive the result for a query that is not the last one, we simply do not process the result
        if (
            _this.lastInputValue !== event.target.value &&
            passTrough == false
        ) {
            return;
        }
        delete _this.queryMap[event.target.value];

        Promise.all(
            responses.map(function (response) {
                return response.text();
            })
        ).then(function (contents) {
            var rValue = false;
            var number_of_items = 4;
            if (contents[0].includes("sr_count")) {
                rValue = true;
                _this.srValue = true;
                number_of_items = 3;
            }
            var searchType = "";
            let searchable = false;
            let searchItemsHTML = "";
            let inputValue = _this.lastInputValue.toLowerCase();
            
            if (window.theme.searches !== '') {
                searchItemsHTML += _this.createLinks(window.theme.searches, inputValue);
            }

            if (window.theme.metaSearches !== '') {
                const metaHTML = _this.createLinks(window.theme.metaSearches, inputValue);
                searchItemsHTML += metaHTML;

                // Ako postoji match – redirect
                if (metaHTML) {
                    const matched = window.theme.metaSearches.find(
                        x => x.metaPage.toLowerCase() === inputValue
                    );
                    if (matched) {
                        requestAnimationFrame(() => {
                            window.location = matched.metaLink;
                        });
                    }
                }
            }

            let searchResult = "";

            if (window.theme.searchMode === "product") {
                if (!_this.srValue && contents[0]) {
                    // Prikaz produkata i pretraženih stavki ako postoje
                    searchResult = `
                        <div class="SearchLayoutSingle">
                            <div class="SearchLayout__Section SearchLayout__Section--Products">
                                ${contents[0]}
                            </div>
                            ${searchItemsHTML ? `
                                <div class="SearchLayout__Section SearchLayout__Section--Pages">
                                    ${searchItemsHTML}
                                </div>` : ""}
                        </div>`;
                } else if (searchItemsHTML) {
                    // Samo pretražene stavke ako nema produkata
                    searchResult = `
                        <div class="SearchLayoutSingle">
                            <div class="SearchLayout__Section SearchLayout__Section--Pages">
                                ${searchItemsHTML}
                            </div>
                        </div>`;
                } else {
                    // Nema rezultata ni za proizvode ni za pretražene stavke
                    searchResult = '<div class="SearchLayoutSingle">\n<div class="SearchLayout__Section SearchLayout__Section--Empty">' +
                    contents[0] +
                    '</div>\n';
                }
            
                searchType = "onlyProduct";
            } else {
                searchResult = `
                <div class="SearchLayout">
                    <div class="SearchLayout__Section SearchLayout__Section--Products">
                        ${contents[0]}
                    </div>
                    ${searchItemsHTML ? `
                        <div class="SearchLayout__Section SearchLayout__Section--Pages">
                            ${searchItemsHTML}
                        </div>` : ""}
                    <div class="SearchLayout__Section SearchLayout__Section--collections"></div>
                    <div class="SearchLayout__Section SearchLayout__Section--secondary">
                        ${contents[1]}
                    </div>
                </div>`;
            }

            _this.loadCollections(
                _this.lastInputValue,
                rValue,
                searchResult,
                event,
                contents,
                searchType
            );
        });
    }

    onInput(event) {

        this.lastInputValue = event.target.value;
        
        var passTrough = false;
        this.srValue = false;
        var _this = this;
        this.searchResultsElement.style.opacity = 0;
        if (event.target.getAttribute("value") && _this.lastInputValue === 0) {
            this.lastInputValue = event.target.getAttribute("value");
            const el = _this.searchElement.querySelector(".SearchInput");
            
            passTrough = true;
            el.setAttribute("value", _this.lastInputValue);
            el.value = _this.lastInputValue;
        } else {
            if (event.keyCode === 13) {
                return;
            }

            // Unfortunately, fetch does not support as of today cancelling a request. As a consequence what we do is that we manually
            // keep track of sent requests, and only use the results of the last one
            if (this.lastInputValue === "") {
                this.initialSearchLayout.style.opacity = 0;
                this.resetSearch();
                return;
            }

           
        }

        var queryOptions = {
            method: "GET",
            credentials: "same-origin",
        };

        var queries = [
            fetch(
                "/search?view=ajax&q=" +
                encodeURIComponent(this.lastInputValue) +
                "*&type=product",
                queryOptions
            ),
        ];

        if (window.theme.searchMode !== "product") {
            queries.push(
                fetch(
                    "/search?view=ajax&q=" +
                    encodeURIComponent(this.lastInputValue) +
                    "*&type=" +
                    window.theme.searchMode.replace("product,", ""),
                    queryOptions
                )
            );
        }

        this.queryMap[this.lastInputValue] = true;

        Promise.all(queries).then(response => {
            this.handleSearchResponses(response, event, passTrough);
        });
    }



    loadCollections(query, rValue, searchResult, eventValue, contents, searchType) {
        var _this = this,
            collectionInner = "";
        this.element.querySelector('.SearchInitial').style.display = "flex";
        this.element.querySelector('.SearchInitial').classList.add('SearchInitial--SecondView');
        return fetch(window.routes.localeRootUrl + "/search/suggest.json?q=" + query + "&resources[type]=collection&resources[limit]=1").then(response => response.json())
            .then(suggestions => {
                const collectionSuggestions = suggestions.resources.results.collections;

                if (collectionSuggestions.length > 0 && window.theme.searchMode !== "product") {
                    _this.searchResultsElement.innerHTML = searchResult;
                    var collectionHTML = '<div class="SearchSegmentHeader"><span class="Segment__Title Search_View--actions u-pb3 primary-text">' + window.languages.collections + '</span><a class="u-h6_new SearchHeader--Primary" href="/search?q=' + query + '*&amp;type=product">' + window.languages.see_all + '</a></div><div class="Segment__Content"></div>';
                    _this.searchElement.querySelector('.SearchLayout__Section--collections').innerHTML = collectionHTML;
                    collectionSuggestions.forEach(function (entry) {
                        collectionInner = collectionInner +
                            '<a href=' + entry.url + ' class="CollectionSearchItem SearchSlide" style="padding-bottom: 100%"><img src=' + entry.featured_image.url + ' class="SearchCollectionImage"><div class="SearchCollectionContent"><h5 class="u-h3 mb-s">' + entry.title + '</h5></div></a>';
                    });
                    _this.searchElement
                        .querySelector('.SearchLayout__Section--collections .Segment__Content').innerHTML = collectionInner;
                } else if (collectionSuggestions.length == 0 && rValue == false && window.theme.searchMode !== "product") {

                    _this.searchResultsElement.innerHTML = searchResult;
                    _this.searchElement.querySelector('.SearchLayout__Section--collections').innerHTML =
                        '<div class="SearchSegmentHeader"><span class="Segment__Title Search_View--actions u-pb3 primary-text">' + window.languages.collections + '</span></div><div class="Segment__Content"><p class="SegmentNoResult primary-text u-p3 pl-l pb-xl">' + window.languages.no_results + '</p></div>';

                } else {
                  if(searchType == "onlyProduct"){
                          _this.searchResultsElement.innerHTML = searchResult;
                                  if (_this.srValue == false ) {  this.element.querySelector('.SearchWrapper').style.height = "auto";}
                  }else{
                    if (this.options['product']) {
                        _this.searchResultsElement.innerHTML =
                            '<div class="SearchLayout__Section SearchInitial--Products Search--Recommendations-noResults"></div>';

                    } else {

                        _this.searchResultsElement.innerHTML =
                            '<div class="SearchLayout__Section Search--Recommendations-noResults">' + contents[0] + '</div>\n ';

                    }
                      if (_this.srValue == true ) { _this.loadRecommendations(3, true); }
                  }


                  //  _this.searchResultsElement.querySelector('.Segment').remove();

                }
                if (window.theme.enableAnimations) { this.timeline = new TimelineLite({ delay: 0.6 }); this.setupAnimation(); }
                _this.searchResultsElement.setAttribute('aria-hidden', 'false');
                if (window.theme.showRecentSearches) { _this.recentSearches(eventValue); }
              //  _this.initCarousel();
                _this.searchResultsElement.style.opacity = 1;


            });

    }



    loadRecommendations(numberOfProducts, rValue) {
        var _this = this;
        var product_to_search = "";
        product_to_search = _this.options['product'];
        if (!numberOfProducts) {
            var numberOfProducts = 6
        }
        var url =
            "/recommendations/products?section_id=search_suggested&product_id=" +
            product_to_search +
            "&limit=10"

        return fetch(url).then(function (response) {
            return response.text().then(function (content) {
                var container = document.createElement("div");
                var contentjq = document.createElement("div");
                contentjq.innerHTML = content;
                container.innerHTML = contentjq.innerHTML;

                _this.element.querySelector(".ProductRecommendations").innerHTML =
                    container.querySelector(".ProductRecommendations").innerHTML;
                if (window.theme.enableAnimations) { this.timeline = new TimelineLite({ delay: 0.6 }); this.setupAnimation(); }
                  _this.initCarousel();

            });
        });
    }
    resetSearch() {
        this.element.querySelector('.SearchInitial').classList.remove('SearchInitial--SecondView');
        this.initialSearchLayout.querySelector('.SearchInitial--Recents').style.opacity = 0;
          this.element.querySelector('.SearchWrapper').style.height = "auto";
            this.searchResultsElement.innerHTML = this.initialSearchLayout.innerHTML;

        const el = this.searchElement.querySelector(".Search__Form");
        el.value = "";
        el.removeAttribute("value");
        this.searchResultsElement.setAttribute("aria-hidden", "false");
        if (window.theme.showRecentSearches) { this.getRecentSearches(); }
        //if (this.options['product']) { this.loadRecommendations(3, true); }
        if (window.theme.enableAnimations) { this.timeline = new TimelineLite({ delay: 0.6 }); this.setupAnimation(); }
        this.element.querySelector('.SearchInitial').style.display = "flex";
      //  this.initCarousel();
        this.searchResultsElement.style.opacity = 1;
        this.searchResultsElement.querySelector('.SearchInitial--Recents').style.opacity = 1;

    }

    recentSearches(event) {
        this.searchResultsElement.style.opacity = 0;
        var _this = this;
        this.lastInputValue = event.target.value;
        if (this.lastInputValue === "") {
            this.initialSearchLayout.style.opacity = 0;
            this.resetSearch();
            return;
        }

        if (this.lastInputValue.length > 3) {
            var searchTerm = JSON.parse(localStorage.getItem("searchTerms") || "[]");
            if (!searchTerm.includes(this.lastInputValue)) {
                searchTerm.unshift(this.lastInputValue);
            }

            // Then, we save the search info into the local storage, by keeping only the 5 most recent
            try {
                localStorage.setItem(
                    "searchTerms",
                    JSON.stringify(searchTerm.slice(0, 5))
                );
            } catch (error) {
                // Do nothing, this may happen in Safari in incognito mode
            }
        }
    }

    getRecentSearches() {
        var appendString = "";
        var items = JSON.parse(localStorage.getItem("searchTerms") || "[]");
        var appElement = this.searchElement.querySelector(
            ".Search--Recent__results"
        );
        if (items.length > 0) {
            items.forEach((id, index) => {
                appendString =
                    appendString +
                    "<li tabIndex='0' class='SearchResults u-p5_new' data-action='search-string' value='" +
                    id +
                    "'>" +
                    id +
                    "</li>";
            });

            appElement.innerHTML = appendString;
        } else {
            var appEl = this.searchElement.querySelector(".Search--Recent");
            appEl.style.display = "none";
        }
        if (window.theme.showSuggestedSearches) {
            const arr = this.options.items;
            arr.sort(function () {
                return 0.5 - Math.random()
            });
            var filtred = arr.filter(function (a) {
                if (!a.includes("_")) {
                    return a;
                }
            });

            var i;
            appendString = "";
            for (i = 0; i < 5; i++) {
                if (filtred[i]) {
                    var filteredResult = filtred[i].replace(":", " ");
                    filteredResult = filteredResult.replace("-", " ");
                    filteredResult = filteredResult.replace('"', '');
                    filteredResult = filteredResult.replace(/[^\w\s!?]/g,'');
                    appendString = appendString + "<li tabindex='0' class='pt-m pb-m u-p5_new' data-action='search-string' value='" + filteredResult + "'>" + filteredResult + "</li>";


                }
            }
            var appElement = this.searchElement.querySelector(
                ".Search--Suggested__results"
            );
            appElement.innerHTML = appendString;
        }
    }
}
customElements.define("search-bar", SearchBar);


/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
    var config = {
        recoverPasswordForm: '#RecoverPassword',
        hideRecoverPasswordLink: '#HideRecoverPasswordLink'
    };

    if (!$(config.recoverPasswordForm).length) {
        return;
    }

    checkUrlHash();
    resetPasswordSuccess();

    $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
    $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

    function onShowHidePasswordForm(evt) {
        evt.preventDefault();
        toggleRecoverPasswordForm();
    }

    function checkUrlHash() {
        var hash = window.location.hash;

        // Allow deep linking to recover password form
        if (hash === '#recover') {
            toggleRecoverPasswordForm();
        }
    }

    /**
     *  Show/Hide recover password form
     */
    function toggleRecoverPasswordForm() {
        $('#RecoverPasswordForm').toggleClass('hide');
        $('#CustomerLoginForm').toggleClass('hide');
    }

    /**
     *  Show reset password success message
     */
    function resetPasswordSuccess() {
        var $formState = $('.reset-password-success');

        // check if reset password form was successfully submited.
        if (!$formState.length) {
            return;
        }

        // show success message
        $('#ResetSuccess').removeClass('hide');
    }
})();


$(document).ready(function() {
    var sections = new slate.Sections();
    sections.register('product', theme.Product);

    // Common a11y fixes
    slate.a11y.pageLinkFocus($(window.location.hash));

    $('.in-page-link').on('click', function(evt) {
        slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
    });

    // Target tables to make them scrollable
    var tableSelectors = '.rte table';

    slate.rte.wrapTable({
        $tables: $(tableSelectors),
        tableWrapperClass: 'rte__table-wrapper',
    });

    // Target iframes to make them responsive
    var iframeSelectors =
        '.rte iframe[src*="youtube.com/embed"],' +
        '.rte iframe[src*="player.vimeo"]';

    slate.rte.wrapIframe({
        $iframes: $(iframeSelectors),
        iframeWrapperClass: 'rte__video-wrapper'
    });

    // Apply a specific class to the html element for browser support of cookies.
    if (slate.cart.cookiesEnabled()) {
        document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
    }

    lowengrip.init();

    $(window).resize(lowengrip.onResize);
    $(document).on("scroll ontouchstart", lowengrip.onScroll);
    $(window).trigger("resize");
    $(window).trigger("scroll");
});

window.lowengrip = {
    animations: function animations() {
        $("[data-anim]").each(function(i, element) {
            var animation = $(element).attr("data-anim");
            var offset = $(element).attr("data-offset");
            var delay = $(element).attr("data-delay");
            var duration = $(element).attr("data-dur");

            $(element).unbind().removeData().waypoint(function() {
                if (delay) {
                    $(element).css("animation-delay", delay);
                }
                if (duration) {
                    $(element).css("animation-duration", duration);
                }
                $(element).addClass("animated").addClass(animation);
            }, { offset: offset ? offset : "90%" });
        });
    },

    header: function header() {
        if ($(window).scrollTop() > 20) {
            $("header.sticky-header").addClass("fixed");
        } else {
            $("header.sticky-header").removeClass("fixed");
        }

        $('.js-search-trigger').on('click', function(e) {
            e.preventDefault();
            $('[data-search-top]').toggleClass('open');
        });
    },

    filters: {
        init: function() {
            lowengrip.filters.trigger();
        },

        trigger: function() {
            $('[data-filters-trigger]').on('click', function() {
                $(this).toggleClass('open');
                $('[data-filters]').slideToggle();

                $('.js-ps').each(function() {
                    var ps = new PerfectScrollbar($(this)[0]);
                });
            })
        },
    },

    fillterTags: function() {
        Shopify.queryParams = {};

        $('.filters ul').each(function() {
            if ($(this).find('input:checkbox:checked').length) {
                $(this).addClass('active');
            }
        });

        $('.js-filter input').change(function(e) {
            var currentTags = [];
            if (Shopify.queryParams.constraint) {
                currentTags = Shopify.queryParams.constraint.split('+');
            }

            var tagName = $(this).attr('id');

            if ($(this).prop('checked')) {
                if (tagName) {
                    var tagPos = currentTags.indexOf(tagName);
                    if (tagPos >= 0) {
                        currentTags.splice(tagPos, 1);
                    } else {
                        if ($(this).parent('.js-filter-main').length) {
                            $('.filters').find('input:checkbox:checked').not($(this)).prop('checked', false);
                            $('.filters').find('ul.active').removeClass('active');
                            delete Shopify.queryParams.constraint;
                            currentTags = []
                        }
                        currentTags.push(tagName);
                    }
                }
                if (currentTags.length) {
                    Shopify.queryParams.constraint = currentTags.join('+');
                } else {
                    delete Shopify.queryParams.constraint;
                }
                lowengrip.filterAjaxClick();
            } else {
                if (tagName) {
                    var tagPos = currentTags.indexOf(tagName);
                    if (tagPos >= 0) {
                        currentTags.splice(tagPos, 1);
                    }
                }

                if (currentTags.length) {
                    Shopify.queryParams.constraint = currentTags.join('+');
                } else {
                    delete Shopify.queryParams.constraint;
                }
                lowengrip.filterAjaxClick();
            }

            if ($(this).parents('ul').find('input:checkbox:checked').length) {
                $(this).parents('ul').addClass('active');
            } else {
                $(this).parents('ul').removeClass('active');
            }
        });

        if (location.search.length) {
            for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
                aKeyValue = aCouples[i].split('=');
                if (aKeyValue.length > 1) {
                    Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
                }
            }
        }
    },

    filterAjaxClick: function(baseLink) {
        delete Shopify.queryParams.page;
        var newurl = lowengrip.filterCreateUrl(baseLink);
        lowengrip.fillterClick = true;
        History.pushState({
            param: Shopify.queryParams
        }, document.title, newurl);
        lowengrip.filterGetContent(newurl, false);
    },

    filterCreateUrl: function(baseLink) {
        var newQuery = $.param(Shopify.queryParams).replace(/%2B/g, '+');
        if (baseLink) {

            if (newQuery != "")
                return baseLink + "?" + newQuery;
            else
                return baseLink;
        }
        return location.pathname + "?" + newQuery;
    },

    filterGetContent: function(newurl, infinity) {
        $.ajax({
            type: 'get',
            url: newurl,
            beforeSend: function() {
                $('body').addClass('loading');
            },

            success: function(data) {
                lowengrip.filterMapData(data, infinity);
                $('body').removeClass('loading');
            },

            error: function(xhr, text) {
                $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
            }
        });
    },

    filterMapData: function(data, infinity) {
        var response = $(data),
            pagination = response.find(".paginate").attr('data-more'),
            current = response.find(".paginate").attr('data-current');


        var productList = response.find(".js-products-grid"),
            no_matches = response.find(".no_matches");

        $(".no_matches").remove();

        if (no_matches.length) {
            $('.js-products-grid').before(no_matches);
        }

        if (pagination == 'true') {
            $(".products__bottom").show();
        } else {
            $(".products__bottom").hide();
        }

        $('.paginate').attr('data-current', current);
        $('.paginate').attr('data-more', pagination);

        if (infinity) {
            $(productList).find('.grid__item').each(function() {
                var $items = $(this);
                $('.js-products-grid').append($items);
                lowengrip.animations();
                Waypoint.refreshAll();
            });
        } else {
            $('.js-products-grid').html('');
            $(productList).find('.grid__item').each(function() {
                var $items = $(this);
                $('.js-products-grid').append($items);
                $('.js-products-grid').find('.grid__item').addClass('fadeInUp animated');
                lowengrip.equalize();
                Waypoint.refreshAll();
            });
        }
    },

    infinityScroll: function() {
        if ($('.template-collection').length) {
            $('.main-footer').waypoint(function(direction) {
                if (direction == 'down') {
                    var paginate = $('.paginate').attr('data-more'),
                        page = parseInt($('.paginate').attr('data-current')) + 1;

                    if (paginate == "true" && page != Shopify.queryParams.page) {
                        Shopify.queryParams.page = page;
                        var newurl = lowengrip.filterCreateUrl();
                        lowengrip.fillterClick = true;
                        lowengrip.filterGetContent(newurl, true);
                    }
                }
            }, { offset: "150%" });
        }
    },

    cart: {
        init: function() {
            lowengrip.cart.container();
            lowengrip.cart.qty();
            lowengrip.cart.add();
            lowengrip.cart.add2();
            lowengrip.cart.add3();

          lowengrip.cart.checkoutDiscount();

          this.element = this;
        },

      checkoutDiscount: function () {
        // prevent double-binding
        if (this._checkoutDiscountBound) return;
        this._checkoutDiscountBound = true;

        document.addEventListener('click', async (e) => {
          // only inside cart drawer
          const cartRoot = e.target.closest('[data-cart]');
          if (!cartRoot) return;

          const btn = e.target.closest('[name="checkout"], a[href="/checkout"]');
          if (!btn) return;

          e.preventDefault();

          try {
            const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json());

            const code =
                cart.discount_codes?.find(d => d.applicable)?.code ||
                cart.items?.flatMap(i => i.discounts || []).find(Boolean)?.title ||
                null;

            // IMPORTANT: Shopify checkout discount param is usually ?discount=CODE (singular)
            const url = code ? `/checkout?discount=${encodeURIComponent(code)}` : '/checkout';
            window.location.href = url;
          } catch (err) {
            // fail open: don't block checkout if cart fetch fails
            window.location.href = '/checkout';
          }
        }, true);
      },

        toggleCart: function(e) {
            e.preventDefault();

            // Close all drawers first
            let drawers = document.querySelectorAll('.drawer.open');
            let drawerWrappers = document.querySelectorAll('.Drawer--wrapper[aria-expanded="true"]');
            let search = document.querySelector('.SearchWrapper[aria-hidden="false"]');

            search?.setAttribute('aria-hidden', 'true');
            drawers.forEach((drawer) => {
                drawer.classList.remove('open');
            });

            drawerWrappers.forEach(() => {
                document.dispatchEvent(
                    new CustomEvent("favorite-drawer:close", { bubbles: true })
                );
            });

            // Toggle cart AFTER closing other drawers
            const cart = $('[data-cart]');
            const willOpen = !cart.hasClass('open');

            if (willOpen) {
                this.openCart();
            } else {
               this.closeCart();
            }
        },

        openCart: function() {
            const cart = $('[data-cart]');
            const overlay = document.querySelector('.pageOverlay');

            cart.attr('aria-hidden', 'false');
            requestAnimationFrame(() => {
                cart.addClass('open');
                overlay?.classList.add('is-visible');
                document.documentElement.classList.add('noScroll');

                document.dispatchEvent(
                    new CustomEvent("cart-drawer:open", { bubbles: true })
                );
            });


        },

        closeCart: function() {
            const cart = $('[data-cart]');
            const overlay = document.querySelector('.pageOverlay');

            cart.removeClass('open');
            overlay?.classList.remove('is-visible');
            document.documentElement.classList.remove('noScroll');

            setTimeout(() => {
                cart.attr('aria-hidden', 'true');
            }, 300)
        },

        container: function() {
            $('[data-cart-trigger]').on('click', this.toggleCart.bind(this));

            const _this = this;
            $('.pageOverlay').on('click', function() {
                if ($('[data-cart]').hasClass('open')) {
                    console.log("ello");
                    
                    _this.closeCart();
                }
            });

            $('[data-drawer-trigger]').on('click', function(e) {
                e.preventDefault();
                // $('[data-drawer]').toggleClass('open');
                // // $('.overlay').fadeToggle(300);
                // document.querySelector('.overlay').classList.add('is-visible');
                // document.documentElement.classList.toggle('noScroll'); 

                /* Close all drawers */
                let drawerWrappers = document.querySelectorAll('.Drawer--wrapper');
                let cart = document.querySelector('.cart');
                let search = document.querySelector('.SearchWrapper');
                let searchElement = search.getAttribute('aria-hidden');

                if (searchElement == 'false'){
                    search.setAttribute('aria-hidden', 'true');
                }
                
                drawerWrappers.forEach((drawerWrapper) => {
                    let drawerExpanded = drawerWrapper.getAttribute('aria-expanded');
                    if (drawerExpanded === 'true'){
                        document.dispatchEvent(
                            new CustomEvent("favorite-drawer:close", {
                              bubbles: true,
                            })
                        )
                    }
                    
                });
                if(cart.classList.contains('open')){
                    cart.classList.remove('open');
                }

                const drawer = $('[data-drawer]');
                const willOpen = !drawer.hasClass('open');

                if (willOpen) {
                    drawer.addClass('open');
                   // $('.overlay').fadeIn(300);
                    document.querySelector('.overlay').classList.add('is-visible');
                    document.documentElement.classList.add('noScroll');
                    document.dispatchEvent(
                    new CustomEvent("drawer:open", { bubbles: true })
                    );
                } else {
                    drawer.removeClass('open');
                   // $('.overlay').fadeOut(300);
                    document.querySelector('.overlay').classList.remove('is-visible');
                    document.documentElement.classList.remove('noScroll');
                    document.body.style.position = 'relative';
                }
            })

            $('.overlay').on('click', function() {
                if ($('[data-drawer]').hasClass('open')) {
            
                    $('[data-drawer]').removeClass('open');
                   // $('.overlay').fadeOut(300);
                   document.querySelector('.overlay').classList.remove('is-visible');
                    document.documentElement.classList.remove('noScroll');
                }
            });
        },

        qty: function() {
            $('.cart').on('click', '.js-decrease', function() {
                var value = $(this).siblings('input').val(),
                    product = $(this).parents('tr').data('product');

                value--;

                if (typeof product !== "undefined") {
                    slate.cart.updateQty(value, product);
                } else {
                    if (value < 0) value = 0
                }
                $(this).siblings('input').val(value);
            });

            $('.cart').on('click', '.js-increase', function() {
                var value = $(this).siblings('input').val(),
                    product = $(this).parents('tr').data('product');

                value++
                $(this).siblings('input').val(value);

                if (typeof product !== "undefined") {
                    slate.cart.updateQty(value, product);
                }
            });

            $('.cart').on('keyup', '.qty input', function() {
                var value = $(this).val(),
                    product = $(this).parents('tr').data('product');

                if (typeof product !== "undefined") {
                    slate.cart.updateQty(value, product);
                }
            });

        },

        refreshCart: function() {
            $('[data-cart-rows]').empty();
            jQuery.get('/cart.js', function(data) {
                data.items.forEach((item, index) => $('[data-cart-rows]')
                    .append('<tr data-product="' + (index + 1) + '" data-key="' + item.key + '"><td class="image"><a href=""><img src="' + item.image + '"></img></a></td><td class="title"><a href="' + item.product_title + '">' + item.product_title + '</a><p>' + item.variant_title + '</p><div class="money"><div id="cart-row-' + index + '"><span class="js-line-price" id="price-' + index + '">' + slate.Currency.formatMoney(item.line_price, theme.moneyFormat) + '</span></div></div></td>' +
                        '<td class="qty"><div class="js-decrease">−</div><input type="number" name="updates[]" id="updates_' + item.key + '" value="' + item.quantity + '" min="0"><div class="js-increase">+</div>' +
                        '</td></tr>'
                    ));

                $('.js-total-price').html(slate.Currency.formatMoney(data.total_price, theme.moneyFormat));
                $('.js-cart-count span').html(data.item_count);
                $('.js-cart-count').addClass('animate swing animated');

                $('body').removeClass('loading');
            }, "json");
        },

        add: function() {
            const _this = this;
            $(document).on('click', '.js-add-cart', function(e) {
                console.log('add to cart')
                e.preventDefault();
                $('body').addClass('loading');
                var cart_rows = $('[data-cart-rows]').find('tr').length;
                var variant_id = $('.product-variants').find(':selected').data('value');
                if ($('.template-product').length) {
                    var object = $('form[action="/cart/add"]').serialize();
                } else {
                    var object = {
                        quantity: 1,
                        id: variant_id
                    };

                }

                jQuery.post('/cart/add.js', object, function(data) {
                        let drawers = document.querySelectorAll('.sizeDrawer_Wrapper');
                        drawers.forEach(function(drawer){
                            drawer.setAttribute('aria-expanded', 'false');
                            drawer.style.display = 'none';
                        });
                        //$('.pageOverlay').removeClass('is-visible');
                        $('.favOverlay').removeClass('is-visible');
                        $('.fav-pageOverlay').removeClass('is-visible');
                        
                        $('.js-cart-count').removeClass('animate swing animated');
                        $('.cart--not-empty').show();
                        $('.checkout__button').show();
                        $('.js-cart-count span').show();
                        $('.cart--empty').hide();

                        if ($('[data-key="' + data.key + '"]').length) {
                            $('[data-key="' + data.key + '"]').remove();
                            cart_rows--;
                        }

                        $('[data-cart-rows]').empty();

                        jQuery.get('/cart.js', function(data) {
                            data.items.forEach((item, index) => $('[data-cart-rows]')
                                .append('<tr data-product="' + (index + 1) + '" data-key="' + item.key + '"><td class="image"><a href=""><img src="' + item.image + '"></img></a></td><td class="title"><a href="' + item.product_title + '">' + item.product_title + '</a><p>' + item.variant_title + '</p><div class="money"><div id="cart-row-' + index + '"><span class="js-line-price" id="price-' + index + '">' + slate.Currency.formatMoney(item.line_price, theme.moneyFormat) + '</span></div></div></td>' +
                                    '<td class="qty"><div class="js-decrease">−</div><input type="number" name="updates[]" id="updates_' + item.key + '" value="' + item.quantity + '" min="0"><div class="js-increase">+</div>' +
                                    '</td></tr>'
                                ));
                                console.log(data.total_price);
                                console.log(slate.Currency.formatMoney(data.total_price, theme.moneyFormat));
                            $('.js-total-price').html(slate.Currency.formatMoney(data.total_price, theme.moneyFormat));
                            $('.js-cart-count span').html(data.item_count);
                            $('.js-cart-count').addClass('animate swing animated');

                            $('body').removeClass('loading');
                        }, "json");

                        _this.openCart();

                        $.iaoAlert({ msg: '"' + data.product_title + '" ' + $('.cart').data('lang-added'), type: "success", mode: "dark", autoHide: true, alertTime: "4000", position: "bottom-right" });

                    }, 'json')
                    .fail(function(error) {
                        $('body').removeClass('loading');
                        $.iaoAlert({ msg: error.responseJSON.description, type: "error", mode: "dark", autoHide: true, alertTime: "4000", position: "bottom-right" });
                    }, 'json');
            });
        },

        add2: function() {
            const _this = this;
            $(document).on('click', '.js-add-cart2', function(e) {
              
                $('body').addClass('loading');
                var cart_rows = $('[data-cart-rows]').find('tr').length;

                    var object = {
                        quantity: 1,
                        id: $(this).data('id')
                    };
                    
                    let favOverlay = document.querySelector('.favOverlay');
                    favOverlay.classList.remove('is-visible');
                    if (window.location.href.indexOf("pages/favourites") > -1) {
                        let favPOverlay = document.querySelector('.fav-pageOverlay');
                        favPOverlay.classList.remove('is-visible');
                    }
                    
                    document.documentElement.classList.remove('noScroll');
                    document.querySelector('.favIcon').style['pointer-events'] = 'unset';
                                    
                    let drawers = document.querySelectorAll('.Drawer--wrapper[aria-expanded="true"]');
                    drawers.forEach(drawer => {
                        drawer.setAttribute('aria-expanded', 'false');
                        let closeButton = drawer.querySelector('.SidebarDrawer__Close');
                        if (closeButton) {
                            closeButton.click();
                        }
                    });
                    
                    

                jQuery.post('/cart/add.js', object, function(data) {
                        $('.js-cart-count').removeClass('animate swing animated');
                        $('.cart--not-empty').show();
                        $('.checkout__button').show();
                        $('.js-cart-count span').show();
                        $('.cart--empty').hide();

                        if ($('[data-key="' + data.key + '"]').length) {
                            $('[data-key="' + data.key + '"]').remove();
                            cart_rows--;
                        }

                        $('[data-cart-rows]').empty();

                        jQuery.get('/cart.js', function(data) {
                            data.items.forEach((item, index) => $('[data-cart-rows]')
                                .append('<tr data-product="' + (index + 1) + '" data-key="' + item.key + '"><td class="image"><a href=""><img src="' + item.image + '"></img></a></td><td class="title"><a href="' + item.product_title + '">' + item.product_title + '</a><p>' + item.variant_title + '</p><div class="money"><div id="cart-row-' + index + '"><span class="js-line-price" id="price-' + index + '">' + slate.Currency.formatMoney(item.line_price, theme.moneyFormat) + '</span></div></div></td>' +
                                    '<td class="qty"><div class="js-decrease">−</div><input type="number" name="updates[]" id="updates_' + item.key + '" value="' + item.quantity + '" min="0"><div class="js-increase">+</div>' +
                                    '</td></tr>'
                                ));
                            $('.js-total-price').html(slate.Currency.formatMoney(data.total_price, theme.moneyFormat));
                            $('.js-cart-count span').html(data.item_count);
                            $('.js-cart-count').addClass('animate swing animated');

                            $('body').removeClass('loading');
                        }, "json");

                        _this.openCart();

                        $.iaoAlert({ msg: '"' + data.product_title + '" ' + $('.cart').data('lang-added'), type: "success", mode: "dark", autoHide: true, alertTime: "4000", position: "bottom-right" });

                    }, 'json')
                    .fail(function(error) {
                        $('body').removeClass('loading');
                        $.iaoAlert({ msg: error.responseJSON.description, type: "error", mode: "dark", autoHide: true, alertTime: "4000", position: "bottom-right" });
                    }, 'json');
            });
        },

        add3: function() {
            const _this = this;
            $(document).on('click', '.js-add-cart3', function(e) {
                e.preventDefault();
                console.log('add to cart');
                
                $('body').addClass('loading');
                
                // Pronađite trenutno otvoreni drawer
                let subdrawer = $(this).closest('.sizeDrawer_Wrapper');
                
                // Dohvati varijantu iz trenutno otvorenog drawer-a
                let variant_id = subdrawer.find('.product-variants').find(':selected').data('value');
                
                let object;
                if ($('.template-product').length) {
                    object = $('form[action="/cart/add"]').serialize();
                } else {
                    object = {
                        quantity: 1,
                        id: variant_id
                    };
                }
        
                console.log(object);
                console.log($(this));

                let drawers = document.querySelectorAll('.Drawer--wrapper[aria-expanded="true"]');
                drawers.forEach(drawer => {
                    drawer.setAttribute('aria-expanded', 'false');
                    let closeButton = drawer.querySelector('.SidebarDrawer__Close');
                    if (closeButton) {
                        closeButton.click();
                    }
                });
        
                jQuery.post('/cart/add.js', object, function(data) {
                    let drawers = document.querySelectorAll('.sizeDrawer_Wrapper');
                    drawers.forEach(function(drawer) {
                        drawer.setAttribute('aria-expanded', 'false');
                        drawer.style.display = 'none';
                    });
                    
                    $('.favOverlay').removeClass('is-visible');
                    $('.fav-pageOverlay').removeClass('is-visible');
                    
                    $('.js-cart-count').removeClass('animate swing animated');
                    $('.cart--not-empty').show();
                    $('.checkout__button').show();
                    $('.js-cart-count span').show();
                    $('.cart--empty').hide();
        
                    if ($('[data-key="' + data.key + '"]').length) {
                        $('[data-key="' + data.key + '"]').remove();
                    }
        
                    $('[data-cart-rows]').empty();
        
                    jQuery.get('/cart.js', function(data) {
                        data.items.forEach((item, index) => $('[data-cart-rows]')
                            .append('<tr data-product="' + (index + 1) + '" data-key="' + item.key + '"><td class="image"><a href=""><img src="' + item.image + '"></img></a></td><td class="title"><a href="' + item.product_title + '">' + item.product_title + '</a><p>' + item.variant_title + '</p><div class="money"><div id="cart-row-' + index + '"><span class="js-line-price" id="price-' + index + '">' + slate.Currency.formatMoney(item.line_price, theme.moneyFormat) + '</span></div></div></td>' +
                                '<td class="qty"><div class="js-decrease">−</div><input type="number" name="updates[]" id="updates_' + item.key + '" value="' + item.quantity + '" min="0"><div class="js-increase">+</div>' +
                                '</td></tr>'
                            ));
                        console.log(data.total_price);
                        console.log(slate.Currency.formatMoney(data.total_price, theme.moneyFormat));
                        $('.js-total-price').html(slate.Currency.formatMoney(data.total_price, theme.moneyFormat));
                        $('.js-cart-count span').html(data.item_count);
                        $('.js-cart-count').addClass('animate swing animated');
        
                        $('body').removeClass('loading');
                    }, "json");

                    _this.openCart();

                    $.iaoAlert({ msg: '"' + data.product_title + '" ' + $('.cart').data('lang-added'), type: "success", mode: "dark", autoHide: true, alertTime: "4000", position: "bottom-right" });
                    document.querySelector('.favIcon').style['pointer-events'] = 'unset';
                    
                }, 'json').fail(function(error) {
                    $('body').removeClass('loading');
                    $.iaoAlert({ msg: error.responseJSON.description, type: "error", mode: "dark", autoHide: true, alertTime: "4000", position: "bottom-right" });
                }, 'json');
            });
        },
    },

    product: {
        init: function() {
            lowengrip.product.info();
            lowengrip.product.related();
            lowengrip.product.swatches();
        },

        info: function() {
            $('[data-info-trigger]').on('click', function() {
                var info = $(this).data('info-trigger');
              
                $('[data-info-trigger]').not($(this)).removeClass('open');
                $(this).toggleClass('open');
                $('[data-info]').not($('[data-info="' + info + '"]')).slideUp(300);
                $('[data-info="' + info + '"]').slideToggle(300);
            })
        },

        related: function() {
            $('[data-related-trigger]').on('click', function() {
                $('[data-related]').toggleClass('open');
                $('.overlay').fadeToggle(300);
            })

            $('.overlay').on('click', function() {
                if ($('[data-related]').hasClass('open')) {
                 
                    $('[data-related]').removeClass('open');
                    $('.overlay').fadeOut(300);
                }
            });
        },

        swatches: function() {
            $('.swatch :radio').change(function() {
                var optionIndex = $(this).closest('.swatch').attr('data-option-index');
                var optionValue = $(this).val();
                $(this)
                    .closest('form')
                    .find('[data-single-option-selector]')
                    .eq(optionIndex)
                    .val(optionValue)
                    .trigger('change');
            });
        }
    },

    equalize: function() {
        $('*[data-equalize]').equalize({ children: '[data-equalize-child]' });
    },

    instagram: function() {
        if ($('#instafeed').length) {
            var feed = new Instafeed({
                get: 'user',
                userId: $('#instafeed').data('user'),
                accessToken: $('#instafeed').data('token'),
                template: '<div class="grid__item small--one-half medium-up--one-sixth"><a href="{{link}}" class="img" target="_blank" style="background-image:url(\'{{image}}\');"></a></div>',
                limit: 6,
                resolution: 'low_resolution'
            });
            feed.run();
        }
    },

    validation: function(_form, _callback, _extend) {
        var options = {};

        $("form").each(function() {
            if ($("form").parent().attr('id') != 'mc_embed_signup') $(this).validate(options);
        });
    },

    readmore: function(_form, _callback, _extend) {

        $('.js-collapse').each(function() {
            var lines = $(this).data('collapse'),
                less = $(this).data('less'),
                more = $(this).data('more'),
                _this = $(this);

            _this.readmore({
                speed: 300,
                collapsedHeight: lines * 24,
                moreLink: '<a href="#">' + more + '</a>',
                lessLink: '<a href="#">' + less + '</a>',
                afterToggle: function() {
                    if (_this.attr('aria-expanded') != 'true') {
                        _this.next('a').addClass('open');
                    } else {
                
                        _this.next('a').removeClass('open');
                    }
                }
            });
        })
    },

    menu: function() {


        if (window.matchMedia("screen and (min-width: 1025px)").matches) {
            $('.js-menu-trigger').hoverIntent(function () {
                  $('.js-menu-trigger').removeClass('underline');
           
                   // Add underline only to the hovered one
                   $(this).addClass('underline');
           
                   $('.menu, .js-menu-trigger').addClass('open');
                   $('.overlay--hover').fadeIn(300);
           
                   if ($(window).scrollTop() < 20) {
                       $('.menu').css('top', "90px");
                       document.querySelector('.SearchWrapper').setAttribute("aria-hidden", "true");
                   } else {
                       $('.menu').css('top', "56px");
                   }
           
                   if ($('.menu-shop').hasClass('open')) {
                       $('.menu-shop, .js-shop-trigger').removeClass('open');
                       $('.menu-shop').attr('data-level', '');
                   }
           });
        }
        
function handleMouseLeave() {
    $('.menu, .js-menu-trigger').removeClass('open');
    $('.menu, .js-menu-trigger').removeClass('underline');
    $('.overlay--hover').fadeOut(300);
    $('.menu').css('top', "");
}

let isMouseLeaveBound = false;

function setupMouseLeaveListener() {
    const mediaQuery = window.matchMedia("(min-width: 740px)");

    function updateListener(e) {
        if (e.matches) {
            if (!isMouseLeaveBound) {
                $('.menu').on('mouseleave', handleMouseLeave);
                isMouseLeaveBound = true;
            }
        } else {
            if (isMouseLeaveBound) {
                $('.menu').off('mouseleave', handleMouseLeave);
                isMouseLeaveBound = false;
            }
        }
    }
    updateListener(mediaQuery);
    mediaQuery.addListener(updateListener);
}
$(document).ready(() => {
    setupMouseLeaveListener();
});
        
 var width = $(window).width();
              var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ? true : width < 1025;
              if(isMobile){
        $(window).scroll(function() {
  if($(window).scrollTop() < 20){
        $('.menu').css('top', "82px");
  }else{
      $('.menu').css('top', "48px");
  }


});
              }else{
                     $(window).scroll(function() {
  if($(window).scrollTop() < 20){
        $('.menu').css('top', "83px");
  }else{
      $('.menu').css('top', "56px");
  }


});
              }

        $('.js-menu-trigger').on('click', function() {
            if ($(window).width() <= 1025) {
              if($(window).scrollTop() < 20){
                      $('.menu').css('top', "82px");
              }else{
                $('.menu').css('top', "48px");
              }

              const menu_hidden = $('.menu').attr('aria-hidden') === "true";
              if (menu_hidden) {
                $('.menu').attr('aria-hidden', 'false');
                requestAnimationFrame(() => {
                    $('.menu,.js-menu-trigger').toggleClass('open');
                    $('html').toggleClass('scrollLock');
                });
              } else {
                $('.menu,.js-menu-trigger').toggleClass('open');
                $('html').toggleClass('scrollLock');

                setTimeout(() => {
                    $('.menu').attr('aria-hidden', 'true');
                }, 300);
              }
            
              $('.menu_2,.js-menu-trigger').removeClass('open');
              var search = document.querySelector('.SearchWrapper')
              search.setAttribute("aria-hidden", "true");
              
              document.dispatchEvent(
                new CustomEvent("mobile-menu:open", {
                    bubbles: true,
                })
              );
                document.querySelector(".SearchWrapper[aria-hidden='false']");
                document.querySelector('.pageOverlay').classList.remove('is-visible');
                document.body.style.position = 'relative';
            }
        });

        $('.js-menu-trigger_2').on('click', function() {
            if ($(window).width() <= 1025) {
              if($(window).scrollTop() < 20){
                      $('.menu_2').css('top', "48px");
              }else{
                $('.menu_2').css('top', "48px");
              }


              $('.menu_2,.js-menu-trigger_2').toggleClass('open');
             
              $('.menu,.js-menu-trigger_2').removeClass('open');
       
              $('.menu,.js-menu-trigger').removeClass('open');
              
            }
        });

        $('.js-menu-close').on('click', function() {
            $('.menu_2,.js-menu-trigger_2').toggleClass('open');
            $('html').toggleClass('scrollLock');
        })

        $('.js-shop-trigger').hoverIntent(function() {
            $('.menu-shop,.js-shop-trigger').addClass('open');
            $('.overlay--hover').fadeIn(300);

            if ($('.menu').hasClass('open')) {
                $('.menu,.js-menu-trigger').removeClass('open');
            }
        });

        $('.overlay--hover').hoverIntent(function() {
      
            $('.menu,.js-menu-trigger,.menu-shop,.js-shop-trigger').removeClass('open');
            $('.menu-shop li').removeClass('hovered');
            $('.overlay--hover').fadeOut(300);
            $('.menu-shop').attr('data-level', '');
        });
    },

    shop: function() {
        $('.menu-shop a').hoverIntent(function() {
            if ($(this).parent().parent().attr('class') == 'parent' && !$(this).next('ul').length) {
                $('.menu-shop').attr('data-level', 'parent-not-hovered');
            } else {
                var currentLevel = $(this).parent().parent().attr('class');
                $('.menu-shop').attr('data-level', currentLevel);
            }
        });

        $('.menu-shop li').hoverIntent(function() {
            $(this).parent().find('li').removeClass('hovered');
            $(this).addClass('hovered');
        });

        $('.menu-shop [data-product]').hoverIntent(function() {
            var handle = $(this).data('product'),
                hero = $(this).next('.hero');

            if (!hero.length) {
                var tpl = $('#hero').html();
                $(this).parent().append(tpl);
                var hero = $(this).next('.hero');

                jQuery.get('/products/' + handle + '.js', function(data) {
                    var img = data.images[0].imgURL('medium');

                    hero.find('h2').html(data.title);
                    hero.find('.prefix').html(data.type);
                    hero.find('.price').html(slate.Currency.formatMoney(data.price, theme.moneyFormat));
                    hero.find('p').html(data.description);
                    hero.find('[data-img]').html('<img src="' + img + '" alt=""/>');
                    hero.find('.btn').attr('data-id', data.variants[0].id);
                    hero.find('.more').attr('href', data.url);

                    setTimeout(function() { hero.addClass('loaded') }, 400);
                }, 'json');
            }
        });

        String.prototype.imgURL = function(size) {
            return this
                .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, '.')
                .replace(/\.jpg|\.png|\.gif|\.jpeg/g, function(match) {
                    return '_' + size + match;
                });
        };
    },

    scrollbar: function() {
        $('.js-ps').each(function() {
            var ps = new PerfectScrollbar($(this)[0]);
        });
    },

    play: function onScroll() {
        $('.play').on('click', function(e) {
            e.preventDefault();
            var video = $(this).parent().find('video');
            video.get(0).play();
            $(this).fadeOut();

            video.on('ended', function() {
                video.parent().find('.play').fadeIn();
            });
        });

        $('.js-video').on('click', function(e) {
            e.preventDefault();
            $(this).get(0).pause();
            $(this).parent().find('.play').fadeIn();
        });
    },

    cookies: function() {
        if (Cookies.get('cookiebar') != "true") {

            $('.cookie-bar').show();
        }

        $('.cookie-bar .btn').click(function(e) {
            e.preventDefault();
            $('.cookie-bar').fadeOut();
            Cookies.set('cookiebar', true, {
                path: '/',
                secure: false,
                domain: '',
                expires: 30
            });
        });
    },

    venobox: function() {
        $('.venobox').venobox();
    },

    lab: function() {
        $('.js-lab').on('click', function(e) {
            $('.item.active').find('.item__more').slideUp();
            $('.item.active').find('.js-lab').show();
            $('.item.active').removeClass('active');

            var item = $(this).parents('.item');

            item.addClass('active');
            item.find('.item__more').slideDown(400, function() {
                $('html, body').animate({
                    scrollTop: item.offset().top - 90
                }, 400);
            });
            $(this).hide();
        });

        $('.js-close-lab').on('click', function(e) {
            var item = $(this).parents('.item');

            item.removeClass('active');
            item.find('.item__more').slideUp(400);
            item.find('.js-lab').show();
        });
    },

    ratings: function() {
        $('#shopify-product-reviews').on('keyup', '.spr-form-review-body textarea', function() {
            $('.spr-form-review-title input').val($('.spr-form-review-body textarea').val());
        });

        setTimeout(function() {
            $('.spr-form-review-body textarea').attr('maxlength', 90)
        }, 2000);
    },

    onResize: function onResize() {},

    onScroll: function onScroll() {},

    init: function init() {
        lowengrip.animations();
        lowengrip.header();
        lowengrip.equalize();
        lowengrip.filters.init();
        lowengrip.fillterTags();
        lowengrip.infinityScroll();
        lowengrip.product.init();
        lowengrip.cart.init();
        lowengrip.instagram();
        lowengrip.validation();
        lowengrip.readmore();
        lowengrip.menu();
        lowengrip.shop();
        lowengrip.scrollbar();
        lowengrip.play();
        lowengrip.cookies();
        lowengrip.venobox();
        lowengrip.lab();
        lowengrip.ratings();
    }
}

$('.size-chart-open-popup').magnificPopup({
    type: 'inline',
    midClick: true
});


const inner = document.querySelector(".imgzoomtwo");
const left = document.querySelector(".imgzoomone");
//inner.addEventListener("mousemove", handleMousemove, false);

function handleMousemove(event) {
    let { width, height } = this.getBoundingClientRect();
    let xAxis = event.offsetX / width * 80;
    let yAxis = event.offsetY / height * 80;
    if (yAxis <= 15) {
        yAxis = 15
    }
    if (yAxis >= 55) {
        yAxis = 55
    }
    if (xAxis <= 60) {
        xAxis = 60
    }
    if (xAxis >= 150) {
        xAxis = 150
    }
    inner.style.transform = `translate(-${xAxis}%, -${yAxis}%)`;
}

const innerone = document.querySelector(".imgzoomtwo1");
const leftone = document.querySelector(".imgzoomone1");
//innerone.addEventListener("mousemove", handleMousemoveone, false);

function handleMousemoveone(event) {
    let { width, height } = this.getBoundingClientRect();
    let xAxisone = event.offsetX / width * 80;
    let yAxisone = event.offsetY / height * 80;
    if (yAxisone <= 15) {
        yAxisone = 15
    }
    if (yAxisone >= 55) {
        yAxisone = 55
    }
    if (xAxisone <= 60) {
        xAxisone = 60
    }
    if (xAxisone >= 150) {
        xAxisone = 150
    }
    innerone.style.transform = `translate(-${xAxisone}%, -${yAxisone}%)`;
}

const innertwo = document.querySelector(".imgzoomtwo2");
const lefttwo = document.querySelector(".imgzoomone2");
//innertwo.addEventListener("mousemove", handleMousemovetwo, false);

function handleMousemovetwo(event) {
    let { width, height } = this.getBoundingClientRect();
    let xAxistwo = event.offsetX / width * 80;
    let yAxistwo = event.offsetY / height * 80;
    if (yAxistwo <= 15) {
        yAxistwo = 15
    }
    if (yAxistwo >= 55) {
        yAxistwo = 55
    }
    if (xAxistwo <= 60) {
        xAxistwo = 60
    }
    if (xAxistwo >= 150) {
        xAxistwo = 150
    }
    innertwo.style.transform = `translate(-${xAxistwo}%, -${yAxistwo}%)`;
}

const innerthree = document.querySelector(".imgzoomtwo3");
const leftthree = document.querySelector(".imgzoomone3");
//innerthree.addEventListener("mousemove", handleMousemovethree, false);

function handleMousemovethree(event) {
    let { width, height } = this.getBoundingClientRect();
    let xAxisthree = event.offsetX / width * 80;
    let yAxisthree = event.offsetY / height * 80;
    if (yAxisthree <= 15) {
        yAxisthree = 15
    }
    if (yAxisthree >= 55) {
        yAxisthree = 55
    }
    if (xAxisthree <= 60) {
        xAxisthree = 60
    }
    if (xAxisthree >= 150) {
        xAxisthree = 150
    }
    innerthree.style.transform = `translate(-${xAxisthree}%, -${yAxisthree}%)`;
}


const innerfour = document.querySelector(".imgzoomtwo4");
const leftfour = document.querySelector(".imgzoomone4");
//innerfour.addEventListener("mousemove", handleMousemovefour, false);

function handleMousemovefour(event) {
    let { width, height } = this.getBoundingClientRect();
    let xAxisfour = event.offsetX / width * 80;
    let yAxisfour = event.offsetY / height * 80;
    if (yAxisfour <= 15) {
        yAxisfour = 15
    }
    if (yAxisfour >= 55) {
        yAxisfour = 55
    }
    if (xAxisfour <= 60) {
        xAxisfour = 60
    }
    if (xAxisfour >= 150) {
        xAxisfour = 150
    }
    innerfour.style.transform = `translate(-${xAxisfour}%, -${yAxisfour}%)`;
}

class NewsletterPopup extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.delegateElement = new Delegate(this.element);
        this.pageOverlayElement = document.querySelector(".pageOverlay--popup");
        this.options = JSON.parse(this.element.getAttribute("data-section-settings"));
        this.handleOpenOptions();
        if (this.options.edit_mode == true) {
            this.options.delay = 0;
            this.openNewsletter();
        }

    }

    handleOpenOptions() {
        let sessionKey = sessionStorage.getItem('popup-seen');
        var localKey = localStorage.getItem('popup-seen');
        if (this.options.show_only_once == true && localKey == "true") {
            return;
        }
        if (sessionKey != "true") {
            if (this.options.scroll_amount > 0) {
                this.scrollListener = this.scrollListener.bind(this);
                document.addEventListener('scroll', this.scrollListener);

            } else {
                this.openNewsletter();
            }
        }
    }

    scrollListener() {
        var _this = this,
            body = document.body,
            html = document.documentElement;
        let docHeight = Math.max(body.scrollHeight, body.offsetHeight,
            html.clientHeight, html.scrollHeight, html.offsetHeight);
        let percScrolled = window.scrollY / docHeight * 100;
        if (percScrolled >= _this.options.scroll_amount) {
            _this.openNewsletter();
            document.removeEventListener("scroll", _this.scrollListener);
        }
    }

    openNewsletter() {
        var _this = this;
        setTimeout(() => {
            this.element.setAttribute('aria-hidden', false);
            this.pageOverlayElement.classList.add("is-visible");
            this.onClickOutsideListener = this.closeNewsletter.bind(this);
            this.pageOverlayElement.addEventListener("click", this.onClickOutsideListener);
            sessionStorage.setItem('popup-seen', true);
            localStorage.setItem('popup-seen', true);
            this.delegateElement.on(
                "click",
                '[data-action="close-modal"]',
                this.closeNewsletter.bind(this)
            );
        }, 1000 * _this.options.delay);
    }

    closeNewsletter() {
        this.element.setAttribute('aria-hidden', true);
        this.pageOverlayElement.classList.remove("is-visible");
        this.pageOverlayElement.removeEventListener("click", this.onClickOutsideListener);
        document.removeEventListener('scroll', this.scrollListener);
    }
}

customElements.define("newsletter-popup", NewsletterPopup);

class selectSize extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.delegateElement = new Delegate(this.element);
       this.newSlider();
    }
        newSlider(){
            
            var slider =$('.size-slider').slick({
                dots: false,
                infinite: false,
                slidesToShow: 6,
                draggable: false,
                touchMove: false,
                arrows: true,
                slidesToScroll: 1,
                nextArrow: '<button type="button" class="product-next"><svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.38673e-06 11.5007C-0.000761705 11.3675 0.0515301 11.2394 0.145333 11.1448L5.30184 5.98611L0.145333 0.827424C-0.0249352 0.628517 -0.0134874 0.332014 0.17161 0.146838C0.356708 -0.0383377 0.653086 -0.0497903 0.851909 0.12055L6.72 5.98611L0.851909 11.8567C0.708085 11.9977 0.493837 12.0389 0.307998 11.9613C0.122159 11.8836 0.000841042 11.7022 8.38673e-06 11.5007Z" fill="#121212"/></svg></button>',
                prevArrow: '<button type="button" class="product-prev"><svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.99987 11.5007C7.00064 11.3675 6.94833 11.2394 6.85448 11.1448L1.6958 5.9861L6.85448 0.827424C7.02482 0.628517 7.01337 0.332013 6.8282 0.146838C6.64302 -0.0383377 6.34652 -0.0497903 6.14761 0.12055L0.277041 5.9861L6.14761 11.8567C6.29149 11.9977 6.50583 12.0389 6.69175 11.9613C6.87767 11.8836 6.99904 11.7022 6.99987 11.5007Z" fill="#121212"/></svg></button>'
            });

            
        }

}

customElements.define("select-size", selectSize);

class LocalizationSelectors extends HTMLElement {
    constructor() {
      super();
      this.element = this;
      let responsive = new Responsive();
      let breakpoint = responsive.getCurrentBreakpoint();
      var selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");
      var location = this.element.getAttribute('data-settings');
  
      if (location == "sidebarMenu") {
        var additionalOverlay = true;
      } else {
        var additionalOverlay = false;
      }
      if (breakpoint != "phone" && breakpoint != "tablet") {
        if (selectBoxes.length > 0) {
          selectBoxes.forEach((item, i) => {
            new RevolutionSelectbox(
              item
            );
          });
        }
      } else {
        if (selectBoxes.length > 0) {
          selectBoxes.forEach((item, i) => {
            new RevolutionSelectbox(
              item, true, additionalOverlay
            );
          });
        }
      }
  
    }
  
  }
  customElements.define("localization-selectors", LocalizationSelectors);


class announcementBar extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.options = JSON.parse(this.element.getAttribute("data-settings"));
             
        if (new Responsive().matchesBreakpoint('lap-and-up')) {
            this.sliderDesktop();
        } else {
            this.sliderMobile();
        }
    }

    sliderDesktop() {
        var _this = this;
        $('.ann_deskSlider').css({
            'visibility': 'hidden',
            'height': '36px',
            'overflow': 'hidden'
        });

        $('.ann_deskSlider').on('init', function(event, slick){
            console.log('Slider initialized');
            var firstSlideHeight = $('.ann_deskSlider .slick-slide').first().outerHeight();
            $('.ann_deskSlider').css('height', firstSlideHeight + 'px');

            $('.ann_deskSlider').css({
                'display': 'block', 
                'height': firstSlideHeight + 'px',
                'visibility': 'visible',
                'overflow': 'hidden'
            });
        });

        $('.ann_deskSlider').slick({
            dots: false,
            infinite: true,
            speed: 500,
            fade: true,
            arrows: false,
            cssEase: 'linear',
            autoplay: true,
            lazyLoad: 'ondemand',
            autoplaySpeed: _this.options['speed']
        });

        $('.ann_deskSlider').on('setPosition', function(){
            var currentSlideHeight = $('.ann_deskSlider .slick-slide.slick-active').outerHeight();
            $('.ann_deskSlider').css('height', currentSlideHeight + 'px');
        });
    }

    sliderMobile(){
        var _this = this;
        var slider = $('.ann_mobSlider').slick({
            dots: false,
            infinite: true,
            speed: 500,
            fade: true,
            arrows: false,
            cssEase: 'linear',
            autoplay: true,
            lazyLoad: 'ondemand',
            autoplaySpeed: _this.options['speed']
          });
  
          slider.on('init', function(event, slick, currentSlide, nextSlide){
            $('.announcement-bar__block').fadeIn(500, linear);
        });
    }

}
customElements.define("announcement-bar", announcementBar);


class productList extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.delegateElement = new Delegate(this.element);
        if (new Responsive().matchesBreakpoint('lap-and-up')) {
            this.newSliderDesktop();
        } else {
            this.newSliderMobile();
        }
        
    }
    newSliderMobile(){
        $('.slick__slider').slick({
            infinite: true,
            slidesToShow: 1.99,
            centerMode: true,
            centerPadding: '0px'
        });
    }

    newSliderDesktop(){
        $('.slick__slider--desk').slick({
            infinite: true,
            slidesToShow: 3.99,
            centerMode: true,
            centerPadding: '0px'
          });
    }

}

customElements.define("product-list", productList);


class sizeGuide extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.delegateElement = new Delegate(this.element);
        this.domDelegate = new Delegate(this.element);
        this.Drawer = new Drawer(this.element);  
        this.carouselElement = this.element.querySelector(".swiper");
        if(this.carouselElement){
            this.carousel = new RevolutionSwiper(this.carouselElement);
        }
        
        this.activeSlide = this.element.querySelector(".sizeGuideInner--tab[aria-expanded='true']");
        this.activeSlide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });


    }
    
    connectedCallback(){
        this.domDelegate.on(
            "click",
            '[data-action="toggle-dropdown-sizeGuide"]',
            this.toggleSizeGuideTabs.bind(this)
        );

        document.addEventListener('size-guide:open', this.handleAnnouncement.bind(this));
        document.addEventListener('size-guide:close', this.handleAnnouncement.bind(this));

    }

    handleAnnouncement(){
        setTimeout(()=>{
            if(this.element.getAttribute("aria-expanded") === "true"){
                document.body.classList.add("size-guide-open");
            } else {
                document.body.classList.remove("size-guide-open");
            }
        }, 200)
            
    }

    toggleSizeGuideTabs(event, target) {
        event.preventDefault(event);

        if(event.target.getAttribute('aria-expanded') === 'true'){

            return;
        } else if (event.target.getAttribute("aria-expanded") === "false") {
            this.closeOpenOne();
            const toOpenID = event.target.getAttribute("tab-id");
            event.target.setAttribute("aria-expanded", "true");
            this.element
            .querySelector(`#${toOpenID}`)
            .setAttribute("aria-hidden", "false");

        }
    }

    closeOpenOne() {
        this.element
            .querySelector(".sizeGuideInner--tab[aria-expanded=true]")
            .setAttribute("aria-expanded", "false");
        this.element
            .querySelector(".sizeGuide--contentDropdown[aria-hidden=false]")
            .setAttribute("aria-hidden", "true");
    }

    

}

customElements.define("size-guide", sizeGuide);

class tableContent extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.delegateElement = new Delegate(this.element);
        this.domDelegate = new Delegate(this.element);
        this.delegateBody = new Delegate(document.body);

        this.activeTable = null;
        this.isDown = false;
        this.startX = 0;
        this.scrollLeft = 0;

        this.setProgressBar();
    }

    connectedCallback(){
        this.delegateElement.on("click",
            ".unit",
            this.toggleActive.bind(this)
        );

        this.delegateBody.on(
            "click",
            '[data-action="toggle-dropdown-sizeGuide"]',
            this.setProgressBar.bind(this)
        );

        let mouseDown = false;
        let startX, scrollLeft;
        const slider = this.element.querySelector(".sizeGuideInner--tableContent ");

        const startDragging = (e) => {
        mouseDown = true;
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
        };

        const stopDragging = (e) => {
        mouseDown = false;
        };

        const move = (e) => {
        e.preventDefault();
        if (!mouseDown) {
            return;
        }
        const x = e.pageX - slider.offsetLeft;
        const scroll = x - startX;
        slider.scrollLeft = scrollLeft - scroll;
        };



        let _this = this;
        document.addEventListener("DOMContentLoaded", () => {
            //reset scrolled table
            const slider = _this.element.querySelectorAll(
            ".sizeGuideInner--tableContent "
            );

            slider.forEach((table) => {
            table.scrollLeft = 0;
            });
        
        });

        slider.addEventListener("mousemove", move, false);
        slider.addEventListener("mousedown", startDragging, false);
        slider.addEventListener("mouseup", stopDragging, false);
        slider.addEventListener("mouseleave", stopDragging, false);

        this.element.querySelectorAll(".sizeGuideInner--tableRowItem").forEach(item => {
            item.addEventListener("mouseenter", () => {
                let colIndex = Array.from(item.parentNode.children).indexOf(item) + 1;
                this.element.querySelectorAll(`.sizeGuideInner--tableRowItem:nth-child(${colIndex})`).forEach(colItem => {
                    colItem.classList.add("hovered");
                });
            });
        
            item.addEventListener("mouseleave", () => {
                this.element.querySelectorAll(".sizeGuideInner--tableRowItem").forEach(colItem => {
                    colItem.classList.remove("hovered");
                });
            });
        });
        
    }    

    setProgressBar(event) {
        if (event) {
          //reset scrolled table
          const slider = this.element.querySelectorAll(
            ".sizeGuideInner--tableContent "
          );
    
          slider.forEach((table) => {
            table.scrollLeft = 0;
          });
        }
    
        const progressBars = this.querySelectorAll(
          '.sizeGuide--contentDropdown .tablePagination'
        );
        const tableContent = this.querySelector(
          '.sizeGuide--contentDropdown .sizeGuideInner--tableContent'
        );
        const progressBarWrapper = this.querySelector(
          '.sizeGuide--contentDropdown .tablePagination--wrapper'
        );

        const table = this.element;
            if (tableContent.clientWidth >= tableContent.scrollWidth) {
                table.classList.remove('after');
              } else {
                table.classList.add('after');
              }

        // Initial width for the progress bar (adjust as needed)
        let initialWidth =
          (tableContent.clientWidth / tableContent.scrollWidth) * 100; //  initial width
    
        // Set initial width for progress bar
        progressBars.forEach((progressBar) => {
            progressBar.style.width = `${initialWidth}%`;
            if (tableContent.clientWidth >= tableContent.scrollWidth) {
              progressBarWrapper.classList.add("remove");
            } else {
              progressBarWrapper.classList.remove("remove");
        
              // Add scroll event listener to update the progress bar width
              tableContent.addEventListener("scroll", () => {
          
                const scrollPercentage =
                  (tableContent.scrollLeft /
                    (tableContent.scrollWidth - tableContent.clientWidth)) *
                  100;
        
        
                const newWidth = Math.max(initialWidth, scrollPercentage);
                progressBar.style.width = `${newWidth}%`;
                if(newWidth == 100){
                    table.classList.remove('after');
                } else {
                    table.classList.add('after');
                }
              });
            }
        })
       
    }

    toggleActive(event){
        this.units = this.element.querySelectorAll('.unit');
        this.units.forEach((item) =>{
            item.classList.remove('active');
        });
        event.target.classList.add('active');
        this.setProgressBar();
        this.dataAction = event.target.getAttribute('data-action');
        if(this.dataAction == 'divide-number'){
            this.divideNumber();
        } else if (this.dataAction == 'multiple-number'){
            this.multipleNumber();
        }
    }

    multipleNumber(){
        console.log('multiple');
        const convertBtn = this.element.querySelector("[data-action='multiple-number']");
        this.conversionRate = parseFloat(convertBtn.getAttribute("data-convert")) || 2.54;
        this.tableCells = this.element.querySelectorAll(".otherRows .sizeGuideInner--tableRowItem p");

        this.tableCells.forEach(cell => {
            this.originalValue = parseFloat(cell.getAttribute("data-value"));
            if (!isNaN(this.originalValue)) {
            this.convertedValue = (this.originalValue * this.conversionRate).toFixed(2);
            cell.textContent = `${this.originalValue}`;
            }
        });

    }

    divideNumber(){
        console.log('divide');
        const convertBtn = this.element.querySelector("[data-action='divide-number']");
        this.conversionRate = parseFloat(convertBtn.getAttribute("data-convert")) || 2.54;
        this.tableCells = this.element.querySelectorAll(".otherRows .sizeGuideInner--tableRowItem p");

        this.tableCells.forEach(cell => {
            this.originalValue = parseFloat(cell.getAttribute("data-value"));
            if (!isNaN(this.originalValue)) {
            this.convertedValue = (this.originalValue / this.conversionRate).toFixed(2);
            cell.textContent = `${this.convertedValue}`;
            }
        });

    }
}
customElements.define('table-content', tableContent)

class MobileMenu extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.delegateElement = new Delegate(this.element);

        this.handleClick = this.openDropdown.bind(this);
    }

    connectedCallback() {
        this.delegateElement.on("click", '[data-action="open-sublink"]', this.handleClick);
    }

    disconnectedCallback() {
        this.delegateElement.off("click", '[data-action="open-sublink"]', this.handleClick);
    }

openDropdown(event) {
    event.preventDefault();
    event.stopPropagation();

    const titleElement = event.target.closest('[data-action="open-sublink"]');
    if (!titleElement) return;

    const clickedSublinks = titleElement.nextElementSibling;
    if (!clickedSublinks || !clickedSublinks.classList.contains('menu-tab-list__sublinks')) return;

    const isCurrentlyVisible = clickedSublinks.getAttribute("aria-hidden") === "false";

    const openTitles = this.element.querySelectorAll(".menu-tab-list__link-title.open");
    const visibleSublinks = this.element.querySelectorAll(".menu-tab-list__sublinks.visible");

    openTitles.forEach(title => title.classList.remove("open"));
    visibleSublinks.forEach(sublink => {
        sublink.setAttribute("aria-hidden", "true");
        sublink.classList.remove("visible");
    });

    if (!isCurrentlyVisible) {
        titleElement.classList.add("open");
        clickedSublinks.setAttribute("aria-hidden", "false");
        clickedSublinks.classList.add("visible");
    }
}
}

customElements.define('mobile-menu', MobileMenu);

class MainHeader extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.delegateElement = new Delegate(this.element);
    }

    connectedCallback() {
        const breakpoint = new Responsive().currentBreakpoint;
        if (breakpoint !== "desk" && breakpoint !== "lap") return;

        this.isHovering = false;


        this.delegateElement.on("mouseover", '[data-action="toggle-menu"]', this.handleMenuItemHover.bind(this));
        this.delegateElement.on("mouseout", '[data-action="toggle-menu"]', (e) => this.closeMenu(e));


        this.delegateElement.on("mouseover", ".hover-menu-container", this.handleMouseOverDropdown.bind(this));
        this.delegateElement.on("mouseout", ".hover-menu-container", (e) => this.closeMenu(e));


    }

    disconnectedCallback() {
        this.delegateElement.destroy();
    }

    handleMenuItemHover(event) {        
        const target = event.target.closest('[data-action="toggle-menu"]');
        const dropdownId = target.getAttribute("aria-controls");
        
        this.showMenu(dropdownId); 
    }

    closeAllMenus(event, exceptionId) {
        let query = `.hover-menu-container[aria-hidden="false"]`;
        if (event === null && exceptionId) query += `:not(#${exceptionId})`; 

        const menu = this.querySelectorAll(query)
        menu.forEach(elem => elem.setAttribute("aria-hidden", true));
    }

    handleMouseOut(event) {        
        this.closeAllMenus(event);

        const overlay = document.querySelector('.pageOverlay');
        overlay?.classList.remove('is-visible');
    }

    showMenu(dropdownId) {
        const dropdown = this.querySelector("#" + dropdownId);
        if (!dropdown) return;

        dropdown.style.display = 'flex';

        requestAnimationFrame(() => {
            dropdown.setAttribute('aria-hidden', 'false');
            const overlay = document.querySelector('.pageOverlay');
            overlay?.classList.add('is-visible');
        })
    }

    handleMouseOverDropdown(event) {
        const dropdown = event.target.closest(".hover-menu-container");
        this.keepOpen = dropdown.id;        
    }

    handleMouseLeftDropdown() {
        this.keepOpen = null;
        this.closeMenu();
    }

    closeMenu(event) {
        requestAnimationFrame(() => {

            // 1) if no event = close
            if (!event) return this.forceClose();

            const to = event.relatedTarget;

            // 2) if we go on dropdown = don't close
            if (to && to.closest && to.closest('.hover-menu-container')) return;

            // 3) if go on same menu itme = don't close
            if (to && to.closest && to.closest('[data-action="toggle-menu"]')) return;

            // 4) close
            this.forceClose();
        });
    }

    forceClose() {
        const menu = this.querySelector('.hover-menu-container[aria-hidden="false"]');
        if (!menu) return;

        menu.setAttribute('aria-hidden', 'true');

        const overlay = document.querySelector('.pageOverlay');
        overlay?.classList.remove('is-visible');

        setTimeout(() => {
            menu.style.display = 'none';
        }, 300);
    }


    // closeMenu() {
    //     requestAnimationFrame(() => {
    //         const menu = this.querySelector('.hover-menu-container[aria-hidden="false"]');
    //         if (!menu || this.keepOpen === menu.id) return;

    //         menu.setAttribute('aria-hidden', 'true');
    
    //         const overlay = document.querySelector('.pageOverlay');
    //         overlay?.classList.remove('is-visible');

    //         setTimeout(() => {
    //             menu.style.display = 'none';
    //         }, 300);
    //     })
    // }
}

customElements.define('header-component', MainHeader);


const observeTrapFocus = (target) => {
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type !== 'attributes') continue;

      const el = mutation.target;

      const isDrawer = el.classList.contains('drawer');
      const isCart = el.classList.contains('cart');
      const isWrapper = el.classList.contains('Drawer--wrapper');

      const isOpen = el.classList.contains('open');
      const isExpanded = el.getAttribute('aria-expanded') === 'true';

      let focusTarget = null;

      // Case 1: drawer ili cart otvaranje
      if ((isDrawer || isCart) && isOpen) {
        focusTarget = el;
      }

      // Case 2: Drawer--wrapper otvara se (aria-expanded)
      if (isWrapper && isExpanded) {
        const nextDrawer = el.querySelector('.CartDrawer, .drawer, .sizeDrawer_Wrapper') ||
                          (el.nextElementSibling?.classList.contains('CartDrawer') ? el.nextElementSibling : null);
        focusTarget = nextDrawer || el;
      }

      if (focusTarget) {
        trapFocus(focusTarget);
      } else {
        removeTrapFocus();
      }
    }
  });

  observer.observe(target, {
    attributes: true,
    attributeFilter: ['class', 'aria-expanded'],
  });
};

document.querySelectorAll('.drawer, .cart, .Drawer--wrapper').forEach(observeTrapFocus);


